// Translation dictionary for the admin panel.
// Keys are the English source strings so missing keys gracefully fall back to English.
const adminTranslations: Record<string, Record<string, string>> = {
  en: {
    // ── Sidebar ───────────────────────────────────────────────
    "Dashboard": "Dashboard",
    "Navigation Links": "Navigation Links",
    "Customers Management": "Customers Management",
    "Doctors Management": "Doctors Management",
    "Plants Management": "Plants Management",
    "Articles Management": "Articles Management",
    "Exhibitions Management": "Exhibitions Management",
    "Activities Management": "Activities Management",
    "Ads Management": "Ads Management",
    "Advertiser Management": "Advertiser Management",
    "Fesilah Cards": "Fesilah Cards",
    "Fesilah Vouchers": "Fesilah Vouchers",
    "Reviews Management": "Reviews Management",
    "Promo Codes": "Promo Codes",
    "Send Notifications": "Send Notifications",
    "Subscription Management": "Subscription Management",
    "Subscription Plans": "Subscription Plans",
    "Subscription History": "Subscription History",
    "AutoRenewal Logs": "AutoRenewal Logs",
    "Platform Management": "Platform Management",
    "Categories": "Categories",
    "Topic": "Topic",
    "Countries": "Countries",
    "Interests": "Interests",
    "Pages Management": "Pages Management",
    "Ad Category": "Ad Category",
    "Ad Type": "Ad Type",
    "Ad Packages": "Ad Packages",
    "Agricultural Influencers": "Agricultural Influencers",
    "Banned Keywords": "Banned Keywords",
    "Account Types": "Account Types",
    "App Settings": "App Settings",
    "Settings": "Settings",
    "App Banners": "App Banners",
    "Contacts": "Contacts",
    "Access Control": "Access Control",
    "System Users": "System Users",
    "Roles": "Roles",
    "Finance & Payments": "Finance & Payments",
    "Reports & Stats": "Reports & Stats",
    "Users Report": "Users Report",
    "Supply & Demand": "Supply & Demand",
    "Ad Categories": "Ad Categories",
    "Advertising Revenue": "Advertising Revenue",
    "Financial Reports": "Financial Reports",
    "Activity Logs": "Activity Logs",
    "Account": "Account",
    "Logout": "Logout",

    // ── Topbar ────────────────────────────────────────────────
    "Search users, ads, reports…": "Search users, ads, reports…",
    "Searching…": "Searching…",
    "No results for": "No results for",
    "Users": "Users",
    "Ads": "Ads",
    "Reports": "Reports",
    "Switch to Light Mode": "Switch to Light Mode",
    "Switch to Dark Mode": "Switch to Dark Mode",
    "Notifications": "Notifications",
    "Mark all read": "Mark all read",
    "No notifications yet": "No notifications yet",
    "View all notifications": "View all notifications",
    "Account Settings": "Account Settings",
    "Fesilah Education": "Fesilah Education",
    "Fesilah Trade": "Fesilah Trade",
    "ago": "ago",

    // ── Footer ────────────────────────────────────────────────
    "About": "About",
    "Support": "Support",

    // ── Dashboard ─────────────────────────────────────────────
    "Home": "Home",
    "Dashboards": "Dashboards",
    "Error loading dashboard": "Error loading dashboard",
    "Total Products": "Total Products",
    "Total Customers": "Total Customers",
    "Total Articles": "Total Articles",
    "Total Activities": "Total Activities",
    "Total Exhibitions": "Total Exhibitions",
    "Total Tickets": "Total Tickets",
    "Unresponded Tickets": "Unresponded Tickets",
    "Opened Tickets": "Opened Tickets",
    "Closed Tickets": "Closed Tickets",
    "Total Subscriptions": "Total Subscriptions",
    "Active Subscriptions": "Active Subscriptions",
    "Expired Subscriptions": "Expired Subscriptions",
    "Customers Status": "Customers Status",
    "Subscribed vs Unsubscribed": "Subscribed vs Unsubscribed",
    "Subscribed Customers": "Subscribed Customers",
    "UnSubscribed Customers": "UnSubscribed Customers",
    "No data available": "No data available",
    "Subscription Purchased Stats": "Subscription Purchased Stats",
    "Customers purchase subscription per month": "Customers purchase subscription per month",
    "Subscription Purchased": "Subscription Purchased",
    "Customers Stats": "Customers Stats",
    "Customers registered per month": "Customers registered per month",
    "Customers Registered": "Customers Registered",
    "Jan": "Jan", "Feb": "Feb", "Mar": "Mar", "Apr": "Apr", "May": "May", "Jun": "Jun",
    "Jul": "Jul", "Aug": "Aug", "Sep": "Sep", "Oct": "Oct", "Nov": "Nov", "Dec": "Dec",

    // ── List pages (Users / Doctors / Items) ──────────────────
    "Customers": "Customers",
    "Doctors": "Doctors",
    "Items": "Items",
    "Name": "Name",
    "Email": "Email",
    "Phone": "Phone",
    "Status": "Status",
    "Actions": "Actions",
    "Image": "Image",
    "Username": "Username",
    "Address": "Address",
    "Account Type": "Account Type",
    "Verification": "Verification",
    "Wallet": "Wallet",
    "Created Date": "Created Date",
    "Category": "Category",
    "Description": "Description",
    "Name Ar": "Name Ar",
    "Is Premium": "Is Premium",
    "Export CSV": "Export CSV",
    "Export": "Export",
    "Exporting...": "Exporting...",
    "Search Name, Email Or Phone..": "Search Name, Email Or Phone..",
    "Search Package Name..": "Search Package Name..",
    "Date Range": "Date Range",
    "All Statuses": "All Statuses",
    "All Verifications": "All Verifications",
    "Green": "Green",
    "Gold": "Gold",
    "All Countries": "All Countries",
    "All Cities": "All Cities",
    "Clear": "Clear",
    "Filter": "Filter",
    "Add User": "Add User",
    "Add Doctor": "Add Doctor",
    "Add New Item": "Add New Item",
    "Action": "Action",
    "Delete": "Delete",
    "Confirm": "Confirm",
    "All Users": "All Users",
    "Email Login": "Email Login",
    "Google": "Google",
    "Apple": "Apple",
    "Guests": "Guests",
    "Active": "Active",
    "Suspended": "Suspended",
    "Inactive": "Inactive",
    "Unverified": "Unverified",
    "N/A": "N/A",
    "No users found": "No users found",
    "Error loading users": "Error loading users",
    "Error loading doctors": "Error loading doctors",
    "Error loading items": "Error loading items",
    "Click to toggle status": "Click to toggle status",
    "Suspend User?": "Suspend User?",
    "Deactivate User?": "Deactivate User?",
    "Deactivated": "Deactivated",
    "Are you sure you want to deactivate": "Are you sure you want to deactivate",
    "Yes, Deactivate": "Yes, Deactivate",
    "Reason for deactivation": "Reason for deactivation",
    "Describe why this account is being deactivated…": "Describe why this account is being deactivated…",
    "The user will be notified with this reason.": "The user will be notified with this reason.",
    "Please enter a reason for deactivation.": "Please enter a reason for deactivation.",
    "Activate User?": "Activate User?",
    "Are you sure you want to suspend": "Are you sure you want to suspend",
    "They won't be able to access the platform.": "They won't be able to access the platform.",
    "Are you sure you want to activate": "Are you sure you want to activate",
    "They will regain access to the platform.": "They will regain access to the platform.",
    "Cancel": "Cancel",
    "Yes, Suspend": "Yes, Suspend",
    "Yes, Activate": "Yes, Activate",
    "Updating…": "Updating…",
    "Add Wallet Balance": "Add Wallet Balance",
    "Current Balance": "Current Balance",
    "Amount to Add": "Amount to Add",
    "Enter amount": "Enter amount",
    "Note (optional)": "Note (optional)",
    "e.g. Refund, bonus credit…": "e.g. Refund, bonus credit…",
    "Adding…": "Adding…",
    "Add Balance": "Add Balance",
    "Failed to export users. Please try again.": "Failed to export users. Please try again.",
    "User deleted successfully!": "User deleted successfully!",
    "Failed to delete user. Please try again.": "Failed to delete user. Please try again.",
    "User status updated successfully!": "User status updated successfully!",
    "Failed to update user status. Please try again.": "Failed to update user status. Please try again.",
    "Please enter a valid amount.": "Please enter a valid amount.",
    "Wallet balance updated!": "Wallet balance updated!",
    "Failed to update wallet. Please try again.": "Failed to update wallet. Please try again.",
    "Doctor deleted successfully!": "Doctor deleted successfully!",
    "Failed to delete doctor. Please try again.": "Failed to delete doctor. Please try again.",
    "Doctor status updated successfully!": "Doctor status updated successfully!",
    "Failed to update doctor status. Please try again.": "Failed to update doctor status. Please try again.",
    "Item deleted successfully!": "Item deleted successfully!",
    "Failed to delete item. Please try again.": "Failed to delete item. Please try again.",
    "Item status updated successfully!": "Item status updated successfully!",
    "Failed to update item status. Please try again.": "Failed to update item status. Please try again.",
    "Premium status updated successfully!": "Premium status updated successfully!",
    "Failed to update premium status. Please try again.": "Failed to update premium status. Please try again.",
    "Please select an action and at least one item": "Please select an action and at least one item",
    "Are you sure?": "Are you sure?",
    "You won't be able to revert this!": "You won't be able to revert this!",
    "Bulk action completed successfully!": "Bulk action completed successfully!",
    "Failed to perform bulk action. Please try again.": "Failed to perform bulk action. Please try again.",

    // ── Articles / Exhibitions / Activities / Notifications ────
    "Title": "Title",
    "Tags": "Tags",
    "Country": "Country",
    "Is Featured": "Is Featured",
    "Main Articles": "Main Articles",
    "Tags List": "Tags List",
    "Add New Article": "Add New Article",
    "Search Article Title..": "Search Article Title..",
    "Article deleted successfully!": "Article deleted successfully!",
    "Failed to delete article. Please try again.": "Failed to delete article. Please try again.",
    "Article status updated successfully!": "Article status updated successfully!",
    "Failed to update article status. Please try again.": "Failed to update article status. Please try again.",
    "Featured status updated successfully!": "Featured status updated successfully!",
    "Failed to update featured status. Please try again.": "Failed to update featured status. Please try again.",
    "Please select an action and at least one article": "Please select an action and at least one article",
    "Error loading articles": "Error loading articles",
    "Exhibitions": "Exhibitions",
    "Add New Exhibition": "Add New Exhibition",
    "Search Exhibition Title..": "Search Exhibition Title..",
    "Exhibition DateTime": "Exhibition DateTime",
    "Exhibition deleted successfully!": "Exhibition deleted successfully!",
    "Failed to delete exhibition. Please try again.": "Failed to delete exhibition. Please try again.",
    "Please select an action and at least one exhibition": "Please select an action and at least one exhibition",
    "Error loading exhibitions": "Error loading exhibitions",
    "Activities": "Activities",
    "Add New Activity": "Add New Activity",
    "Search Activity Title..": "Search Activity Title..",
    "Activity DateTime": "Activity DateTime",
    "Activity deleted successfully!": "Activity deleted successfully!",
    "Failed to delete activity. Please try again.": "Failed to delete activity. Please try again.",
    "Please select an action and at least one activity": "Please select an action and at least one activity",
    "Error loading activities": "Error loading activities",
    "Sent Notifications": "Sent Notifications",
    "Send New Notification": "Send New Notification",
    "Body": "Body",
    "Target": "Target",
    "Method": "Method",
    "Sent At": "Sent At",
    "Pending": "Pending",
    "No notifications found": "No notifications found",
    "Error loading notifications": "Error loading notifications",

    // ── Contacts / Categories / Countries / Cities / Banners / Topics ──
    "Website Contacts": "Website Contacts",
    "Search by Name, email...": "Search by Name, email...",
    "Full Name": "Full Name",
    "Email address": "Email address",
    "Message": "Message",
    "No contacts found": "No contacts found",
    "Error loading contacts": "Error loading contacts",
    "Main Categories": "Main Categories",
    "Search Category Title..": "Search Category Title..",
    "Add New Category": "Add New Category",
    "Title Arabic": "Title Arabic",
    "Name Arabic": "Name Arabic",
    "Properties": "Properties",
    "SubCategories": "SubCategories",
    "Category deleted successfully!": "Category deleted successfully!",
    "Failed to delete category. Please try again.": "Failed to delete category. Please try again.",
    "Category status updated successfully!": "Category status updated successfully!",
    "Failed to update category status. Please try again.": "Failed to update category status. Please try again.",
    "Error loading categories": "Error loading categories",
    "Add New Country": "Add New Country",
    "Search Country Name..": "Search Country Name..",
    "Currency": "Currency",
    "Cities": "Cities",
    "Country deleted successfully!": "Country deleted successfully!",
    "Failed to delete country. Please try again.": "Failed to delete country. Please try again.",
    "Country status updated successfully!": "Country status updated successfully!",
    "Failed to update country status. Please try again.": "Failed to update country status. Please try again.",
    "Activate": "Activate",
    "Deactivate": "Deactivate",
    "Error loading countries": "Error loading countries",
    "Cities in": "Cities in",
    "Add New City": "Add New City",
    "Search City Name..": "Search City Name..",
    "City deleted successfully!": "City deleted successfully!",
    "Failed to delete city. Please try again.": "Failed to delete city. Please try again.",
    "Error loading cities": "Error loading cities",
    "Add New Banner": "Add New Banner",
    "Search Banner Title..": "Search Banner Title..",
    "Banner deleted successfully!": "Banner deleted successfully!",
    "Failed to delete banner. Please try again.": "Failed to delete banner. Please try again.",
    "Error loading banners": "Error loading banners",
    "Add New Topic": "Add New Topic",
    "Search Topic Title..": "Search Topic Title..",
    "Topic deleted successfully!": "Topic deleted successfully!",
    "Failed to delete topic. Please try again.": "Failed to delete topic. Please try again.",
    "Topic status updated successfully!": "Topic status updated successfully!",
    "Failed to update topic status. Please try again.": "Failed to update topic status. Please try again.",
    "Topic premium status updated successfully!": "Topic premium status updated successfully!",
    "Failed to update topic premium status. Please try again.": "Failed to update topic premium status. Please try again.",
    "Error loading topics": "Error loading topics",

    // ── Forms & Detail/View pages (common) ────────────────────
    "Discard": "Discard",
    "Submit": "Submit",
    "Back": "Back",
    "Please wait...": "Please wait...",
    "Content": "Content",
    "Content Arabic": "Content Arabic",
    "Content (Arabic)": "Content (Arabic)",
    "Title (Arabic)": "Title (Arabic)",
    "Description Arabic": "Description Arabic",
    "Description (Arabic)": "Description (Arabic)",
    "Tags Arabic": "Tags Arabic",
    "Tags Ar": "Tags Ar",
    "Select Tags": "Select Tags",
    "Select Tags Arabic": "Select Tags Arabic",
    "Note": "Note",
    "Note Arabic": "Note Arabic",
    "Location": "Location",
    "Location Ar": "Location Ar",
    "Select Country": "Select Country",
    "Upload Picture": "Upload Picture",
    "Write tags and press enter": "Write tags and press enter",
    "Write arabic tags and press enter": "Write arabic tags and press enter",
    "Doctor": "Doctor",
    "Topics": "Topics",
    "Start Date": "Start Date",
    "End Date": "End Date",
    // Articles form/view
    "Edit Article": "Edit Article",
    "Articles": "Articles",
    "Article Details": "Article Details",
    "Article not found": "Article not found",
    "Enter Article Title": "Enter Article Title",
    "Enter Article Title in Arabic": "Enter Article Title in Arabic",
    "Upload Article Image": "Upload Article Image",
    "Article updated successfully!": "Article updated successfully!",
    "Article created successfully!": "Article created successfully!",
    "Failed to update article. Please try again.": "Failed to update article. Please try again.",
    "Failed to create article. Please try again.": "Failed to create article. Please try again.",
    // Exhibitions form/view
    "Edit Exhibition": "Edit Exhibition",
    "Exhibition Details": "Exhibition Details",
    "Exhibition not found": "Exhibition not found",
    "Enter Exhibition Title": "Enter Exhibition Title",
    "Enter Exhibition Title in Arabic": "Enter Exhibition Title in Arabic",
    "Enter Exhibition Note": "Enter Exhibition Note",
    "Enter Exhibition Note in Arabic": "Enter Exhibition Note in Arabic",
    "Entrance Fee": "Entrance Fee",
    "Enter Exhibition Entrance Fee": "Enter Exhibition Entrance Fee",
    "Booking Link (optional)": "Booking Link (optional)",
    "Enter Exhibition Booking link if its paid entrance": "Enter Exhibition Booking link if its paid entrance",
    "Exhibition Link": "Exhibition Link",
    "Enter Exhibition link": "Enter Exhibition link",
    "Enter Exhibition Location": "Enter Exhibition Location",
    "Enter Exhibition Location Arabic": "Enter Exhibition Location Arabic",
    "Exhibition At": "Exhibition At",
    "Exhibition updated successfully!": "Exhibition updated successfully!",
    "Exhibition created successfully!": "Exhibition created successfully!",
    "Failed to update exhibition. Please try again.": "Failed to update exhibition. Please try again.",
    "Failed to create exhibition. Please try again.": "Failed to create exhibition. Please try again.",
    // Activities form
    "Edit Activity": "Edit Activity",
    "Enter Activity Title": "Enter Activity Title",
    "Enter Activity Title in Arabic": "Enter Activity Title in Arabic",
    "Enter Activity Note": "Enter Activity Note",
    "Enter Activity Note in Arabic": "Enter Activity Note in Arabic",
    "Activity Link": "Activity Link",
    "Enter Activity Link": "Enter Activity Link",
    "Enter Entrance Fee": "Enter Entrance Fee",
    "Enter Activity Booking link if its paid entrance": "Enter Activity Booking link if its paid entrance",
    "Enter Activity Location": "Enter Activity Location",
    "Enter Activity Location Arabic": "Enter Activity Location Arabic",
    "Activity At": "Activity At",
    "Enter Activity Doctor/Professor": "Enter Activity Doctor/Professor",
    "Activity updated successfully!": "Activity updated successfully!",
    "Activity created successfully!": "Activity created successfully!",
    "Failed to update activity. Please try again.": "Failed to update activity. Please try again.",
    "Failed to create activity. Please try again.": "Failed to create activity. Please try again.",
    // Notification form
    "Send Notification": "Send Notification",
    "Notification Title": "Notification Title",
    "Enter notification title": "Enter notification title",
    "Notification Body": "Notification Body",
    "Enter notification content": "Enter notification content",
    "Image (Optional)": "Image (Optional)",
    "Remove Image": "Remove Image",
    "Click to upload image": "Click to upload image",
    "Recommended: JPEG or PNG, max 5MB. Shown in push notifications and emails.": "Recommended: JPEG or PNG, max 5MB. Shown in push notifications and emails.",
    "Target Users": "Target Users",
    "All Active Users": "All Active Users",
    "New Users (Last 30 days)": "New Users (Last 30 days)",
    "Old Users (Before 30 days)": "Old Users (Before 30 days)",
    "Specific Users": "Specific Users",
    "Search & Select Users": "Search & Select Users",
    "Search by name, email or phone...": "Search by name, email or phone...",
    "Add": "Add",
    "Send Method": "Send Method",
    "Push & Email": "Push & Email",
    "Push Notification Only": "Push Notification Only",
    "Email Only": "Email Only",
    "Target Country (Optional)": "Target Country (Optional)",
    "Leave empty to send to users in all countries.": "Leave empty to send to users in all countries.",
    "Target City (Optional)": "Target City (Optional)",
    "Select a country first": "Select a country first",
    "Leave empty to send to users in all cities of the selected country.": "Leave empty to send to users in all cities of the selected country.",
    "Send Time": "Send Time",
    "Send Now": "Send Now",
    "Schedule for Later": "Schedule for Later",
    "Schedule Notification": "Schedule Notification",
    "Please select a valid image file": "Please select a valid image file",
    "Please select at least one user": "Please select at least one user",
    "Please select a scheduled date and time": "Please select a scheduled date and time",
    "Notification queued successfully": "Notification queued successfully",
    "Failed to send notification": "Failed to send notification",

    // ── User / Doctor / Item forms + Packages / Subscriptions / Stripe ──
    "Edit User": "Edit User",
    "Enter Package Name": "Enter Package Name",
    "Enter User Email": "Enter User Email",
    "Enter Phone No.": "Enter Phone No.",
    "City": "City",
    "Select City": "Select City",
    "Select Account Type": "Select Account Type",
    "No Account Type": "No Account Type",
    "User updated successfully!": "User updated successfully!",
    "User created successfully!": "User created successfully!",
    "Failed to update user. Please try again.": "Failed to update user. Please try again.",
    "Failed to create user. Please try again.": "Failed to create user. Please try again.",
    "Edit Doctor": "Edit Doctor",
    "Add New Doctor": "Add New Doctor",
    "Enter Doctor name": "Enter Doctor name",
    "Email Address": "Email Address",
    "Enter Doctor Email Address": "Enter Doctor Email Address",
    "Password": "Password",
    "(Password can't be viewed but can update from here)": "(Password can't be viewed but can update from here)",
    "Enter Password": "Enter Password",
    "Phone No": "Phone No",
    "Enter Phone Number": "Enter Phone Number",
    "Topic:": "Topic:",
    "Select Doctor Categories": "Select Doctor Categories",
    "Password is required for new doctors": "Password is required for new doctors",
    "Doctor updated successfully!": "Doctor updated successfully!",
    "Doctor created successfully!": "Doctor created successfully!",
    "Failed to update doctor. Please try again.": "Failed to update doctor. Please try again.",
    "Failed to create doctor. Please try again.": "Failed to create doctor. Please try again.",
    "Edit Item": "Edit Item",
    "Enter Item Name": "Enter Item Name",
    "Enter Item Name in Arabic": "Enter Item Name in Arabic",
    "Category:": "Category:",
    "Select Category": "Select Category",
    "SubCategory:": "SubCategory:",
    "Select SubCategories": "Select SubCategories",
    "Write Description": "Write Description",
    "Write Description in Arabic": "Write Description in Arabic",
    "Upload Images": "Upload Images",
    "Item Properties": "Item Properties",
    "Item created successfully!": "Item created successfully!",
    "Failed to update item. Please try again.": "Failed to update item. Please try again.",
    "Failed to create item. Please try again.": "Failed to create item. Please try again.",
    "Packages": "Packages",
    "Add New Package": "Add New Package",
    "Price": "Price",
    "Duration": "Duration",
    "Package deleted successfully!": "Package deleted successfully!",
    "Failed to delete package. Please try again.": "Failed to delete package. Please try again.",
    "Package status updated successfully!": "Package status updated successfully!",
    "Failed to update package status. Please try again.": "Failed to update package status. Please try again.",
    "Error loading packages": "Error loading packages",
    "Subscriptions": "Subscriptions",
    "Select User": "Select User",
    "Select Package": "Select Package",
    "User": "User",
    "Package": "Package",
    "Purchase/Renew Date": "Purchase/Renew Date",
    "Expired Date": "Expired Date",
    "Is Auto Renewed": "Is Auto Renewed",
    "Yes": "Yes",
    "No": "No",
    "Expired": "Expired",
    "Error loading subscription history": "Error loading subscription history",
    "Stripe AutoRenewal logs": "Stripe AutoRenewal logs",
    "Error": "Error",
    "Details": "Details",
    "Error At": "Error At",
    "Error loading auto-renewal logs": "Error loading auto-renewal logs",

    // ── PackageForm/View, ItemView, Category/Country/City/Topic forms+views, BannerForm ──
    "Edit Package": "Edit Package",
    "Package Name": "Package Name",
    "Package Name Arabic": "Package Name Arabic",
    "Enter Package Name in Arabic": "Enter Package Name in Arabic",
    "Time Period": "Time Period",
    "Enter Time Period": "Enter Time Period",
    "months": "months",
    "days": "days",
    "Enter Package Price": "Enter Package Price",
    "Add Features": "Add Features",
    "write feature here": "write feature here",
    "write feature in arabic": "write feature in arabic",
    "- Remove": "- Remove",
    "Package updated successfully!": "Package updated successfully!",
    "Package created successfully!": "Package created successfully!",
    "Failed to update package. Please try again.": "Failed to update package. Please try again.",
    "Failed to create package. Please try again.": "Failed to create package. Please try again.",
    "Package Details": "Package Details",
    "Package not found": "Package not found",
    "Name (Arabic)": "Name (Arabic)",
    "Features": "Features",
    "Features (Arabic)": "Features (Arabic)",
    "Item Details": "Item Details",
    "Item not found": "Item not found",
    "Images": "Images",
    "Edit Category": "Edit Category",
    "Enter Category Title": "Enter Category Title",
    "Enter Category Title in Arabic": "Enter Category Title in Arabic",
    "Upload Banner": "Upload Banner",
    "Category created successfully!": "Category created successfully!",
    "Failed to update category. Please try again.": "Failed to update category. Please try again.",
    "Failed to create category. Please try again.": "Failed to create category. Please try again.",
    "Category Details": "Category Details",
    "Category not found": "Category not found",
    "Edit Country": "Edit Country",
    "Enter Country Name": "Enter Country Name",
    "Enter Country Name in Arabic": "Enter Country Name in Arabic",
    "Currency Code": "Currency Code",
    "ISO 4217 currency code (3 letters)": "ISO 4217 currency code (3 letters)",
    "Currency Code Arabic": "Currency Code Arabic",
    "Arabic currency symbol or code": "Arabic currency symbol or code",
    "e.g. USD, AED, SAR": "e.g. USD, AED, SAR",
    "e.g. د.إ, ر.س, د.ك": "e.g. د.إ, ر.س, د.ك",
    "Name is required and must be at least 3 characters long.": "Name is required and must be at least 3 characters long.",
    "Name Arabic is required and must be at least 3 characters long.": "Name Arabic is required and must be at least 3 characters long.",
    "Validation failed": "Validation failed",
    "Country updated successfully!": "Country updated successfully!",
    "Country created successfully!": "Country created successfully!",
    "Failed to update country. Please try again.": "Failed to update country. Please try again.",
    "Failed to create country. Please try again.": "Failed to create country. Please try again.",
    "Edit City": "Edit City",
    "Enter City Name": "Enter City Name",
    "Enter City Name in Arabic": "Enter City Name in Arabic",
    "City updated successfully!": "City updated successfully!",
    "City created successfully!": "City created successfully!",
    "Failed to update city. Please try again.": "Failed to update city. Please try again.",
    "Failed to create city. Please try again.": "Failed to create city. Please try again.",
    "Edit Topic": "Edit Topic",
    "Enter Topic Name": "Enter Topic Name",
    "Enter Topic Name in Arabic": "Enter Topic Name in Arabic",
    "Mark as Premium": "Mark as Premium",
    "Topic created successfully!": "Topic created successfully!",
    "Failed to update topic. Please try again.": "Failed to update topic. Please try again.",
    "Failed to create topic. Please try again.": "Failed to create topic. Please try again.",
    "Topic Details": "Topic Details",
    "Topic not found": "Topic not found",
    "Language": "Language",
    "Sort Order": "Sort Order",
    "Edit Banner": "Edit Banner",
    "Enter Banner Title": "Enter Banner Title",
    "Enter Banner Title in Arabic": "Enter Banner Title in Arabic",
    "Link To": "Link To",
    "Exhibition": "Exhibition",
    "Activity": "Activity",
    "Article": "Article",
    "External URL": "External URL",
    "No Link": "No Link",
    "Select Exhibition": "Select Exhibition",
    "Select Activity": "Select Activity",
    "Select Article": "Select Article",
    "Search and select...": "Search and select...",
    "Enter External URL": "Enter External URL",
    "Enter Sort Order (0, 1, 2...)": "Enter Sort Order (0, 1, 2...)",
    "Lower numbers appear first. Default: 0": "Lower numbers appear first. Default: 0",
    "Banner Image": "Banner Image",
    "Upload Banner Image": "Upload Banner Image",
    "Please select a link type.": "Please select a link type.",
    "Please select a link option.": "Please select a link option.",
    "Please enter an external URL.": "Please enter an external URL.",
    "Please upload a banner image.": "Please upload a banner image.",
    "Banner updated successfully!": "Banner updated successfully!",
    "Banner created successfully!": "Banner created successfully!",
    "Failed to update banner. Please try again.": "Failed to update banner. Please try again.",
    "Failed to create banner. Please try again.": "Failed to create banner. Please try again.",

    // ── Interests / Pages / Account Types ─────────────────────
    "Interest deleted successfully": "Interest deleted successfully",
    "Failed to delete interest": "Failed to delete interest",
    "Interest activated successfully": "Interest activated successfully",
    "Interest deactivated successfully": "Interest deactivated successfully",
    "Failed to update status": "Failed to update status",
    "Error loading interests": "Error loading interests",
    "Add Interest": "Add Interest",
    "ID": "ID",
    "Name (AR)": "Name (AR)",
    "No interests found": "No interests found",
    "Edit Interest": "Edit Interest",
    "Add New Interest": "Add New Interest",
    "Enter Interest Name": "Enter Interest Name",
    "Enter Interest Name in Arabic": "Enter Interest Name in Arabic",
    "Name is required and must be at least 2 characters long.": "Name is required and must be at least 2 characters long.",
    "Arabic Name is required and must be at least 2 characters long.": "Arabic Name is required and must be at least 2 characters long.",
    "Interest updated successfully!": "Interest updated successfully!",
    "Interest created successfully!": "Interest created successfully!",
    "Failed to update interest. Please try again.": "Failed to update interest. Please try again.",
    "Failed to create interest. Please try again.": "Failed to create interest. Please try again.",
    "Pages": "Pages",
    "Search Page Title..": "Search Page Title..",
    "Add New Page": "Add New Page",
    "Page deleted successfully!": "Page deleted successfully!",
    "Failed to delete page. Please try again.": "Failed to delete page. Please try again.",
    "Error loading pages": "Error loading pages",
    "Edit Page": "Edit Page",
    "Enter Page Title": "Enter Page Title",
    "Enter Page Title in Arabic": "Enter Page Title in Arabic",
    "Page updated successfully!": "Page updated successfully!",
    "Page created successfully!": "Page created successfully!",
    "Failed to update page. Please try again.": "Failed to update page. Please try again.",
    "Failed to create page. Please try again.": "Failed to create page. Please try again.",
    "Page Details": "Page Details",
    "Page not found": "Page not found",
    "Slug": "Slug",
    "Status updated!": "Status updated!",
    "Failed to update status.": "Failed to update status.",
    "Account type deleted!": "Account type deleted!",
    "Failed to delete account type.": "Failed to delete account type.",
    "Error loading account types": "Error loading account types",
    "Search account type...": "Search account type...",
    "Add Account Type": "Add Account Type",
    "Created": "Created",
    "No account types found": "No account types found",
    "Edit Account Type": "Edit Account Type",
    "New Account Type": "New Account Type",
    "Edit": "Edit",
    "Title (English)": "Title (English)",
    "e.g. Individual": "e.g. Individual",
    "e.g. فردي": "e.g. فردي",
    "Saving...": "Saving...",
    "Update": "Update",
    "Create": "Create",
    "Title is required (min 2 characters).": "Title is required (min 2 characters).",
    "Arabic title is required (min 2 characters).": "Arabic title is required (min 2 characters).",
    "Account type updated!": "Account type updated!",
    "Account type created!": "Account type created!",
    "Something went wrong.": "Something went wrong.",

    // ── Ad Types ──────────────────────────────────────────────
    "Ad Type status updated successfully!": "Ad Type status updated successfully!",
    "Failed to update ad type status. Please try again.": "Failed to update ad type status. Please try again.",
    "Ad Type deleted successfully!": "Ad Type deleted successfully!",
    "Failed to delete ad type. Please try again.": "Failed to delete ad type. Please try again.",
    "Error loading ad types": "Error loading ad types",
    "Ad Types": "Ad Types",
    "Search Ad Type Title..": "Search Ad Type Title..",
    "Add New Ad Type": "Add New Ad Type",
    "Features Count": "Features Count",
    "No ad types found": "No ad types found",
    "Strategic Ad Types": "Strategic Ad Types",
    "Edit Ad Type": "Edit Ad Type",
    "Enter Ad Type Title": "Enter Ad Type Title",
    "Enter Ad Type Title in Arabic": "Enter Ad Type Title in Arabic",
    "Mark as Free": "Mark as Free",
    "Free": "Free",
    "Images Limit": "Images Limit",
    "Enter Images Limit": "Enter Images Limit",
    "Analytics Available": "Analytics Available",
    "Targeting Available": "Targeting Available",
    "Notification Sent": "Notification Sent",
    "External Links Allowed": "External Links Allowed",
    "Duration Days": "Duration Days",
    "e.g. 15 to 30 days": "e.g. 15 to 30 days",
    "Placement": "Placement",
    "Select Placement": "Select Placement",
    "Relevant Section": "Relevant Section",
    "Premium": "Premium",
    "Strategic": "Strategic",
    "Ordering": "Ordering",
    "Select Ordering": "Select Ordering",
    "Chronological": "Chronological",
    "Priority": "Priority",
    "Prominent": "Prominent",
    "Editable": "Editable",
    "Select Editable Option": "Select Editable Option",
    "Once Only": "Once Only",
    "Flexible": "Flexible",
    "Ad Type updated successfully!": "Ad Type updated successfully!",
    "Ad Type created successfully!": "Ad Type created successfully!",
    "Failed to update ad type. Please try again.": "Failed to update ad type. Please try again.",
    "Failed to create ad type. Please try again.": "Failed to create ad type. Please try again.",
    "Title is required and must be at least 3 characters long.": "Title is required and must be at least 3 characters long.",
    "Title Arabic is required and must be at least 3 characters long.": "Title Arabic is required and must be at least 3 characters long.",
    // ── Reports pages (Users / Supply-Demand / Ad Categories / Advertising / Financial) ──────────
    "Active campaigns": "Active campaigns",
    "Ad Categories Report": "Ad Categories Report",
    "Ad Distribution by Type": "Ad Distribution by Type",
    "Ad Types / Sections": "Ad Types / Sections",
    "Ads per sub-type": "Ads per sub-type",
    "All cities": "All cities",
    "All countries": "All countries",
    "All statuses": "All statuses",
    "Average session duration": "Average session duration",
    "Average session in minutes (top 10 countries)": "Average session in minutes (top 10 countries)",
    "Average spending per advertiser": "Average spending per advertiser",
    "Average user rating": "Average user rating",
    "Avg. Minutes": "Avg. Minutes",
    "Avg. Session Duration Per Country": "Avg. Session Duration Per Country",
    "Balanced": "Balanced",
    "Balanced only": "Balanced only",
    "Breakdown of ads per sub-type, with supply vs. demand overview": "Breakdown of ads per sub-type, with supply vs. demand overview",
    "CTR": "CTR",
    "Categories Monitored": "Categories Monitored",
    "Communications": "Communications",
    "Conversion Funnel": "Conversion Funnel",
    "Daily active users": "Daily active users",
    "Deficit Gaps": "Deficit Gaps",
    "Deficit only": "Deficit only",
    "Device distribution": "Device distribution",
    "Distribution of advertising spending by package and category": "Distribution of advertising spending by package and category",
    "Failed to load report": "Failed to load report",
    "Foreign": "Foreign",
    "Gap": "Gap",
    "Gross Revenue": "Gross Revenue",
    "Gross advertising revenues broken down by ad category": "Gross advertising revenues broken down by ad category",
    "Gross advertising revenues broken down by ad type": "Gross advertising revenues broken down by ad type",
    "Gross advertising revenues broken down by advertiser city": "Gross advertising revenues broken down by advertiser city",
    "Gross advertising revenues broken down by advertiser country": "Gross advertising revenues broken down by advertiser country",
    "Item": "Item",
    "Items generating the highest engagement in this category": "Items generating the highest engagement in this category",
    "Key Strategic Gaps": "Key Strategic Gaps",
    "Local": "Local",
    "Local vs. Foreign Advertisers": "Local vs. Foreign Advertisers",
    "Minutes": "Minutes",
    "Monthly Ad Trend": "Monthly Ad Trend",
    "New Ads": "New Ads",
    "New This Period": "New This Period",
    "New users": "New users",
    "No advertiser data available": "No advertiser data available",
    "No categories": "No categories",
    "No categories match your filters.": "No categories match your filters.",
    "No category data available for this period": "No category data available for this period",
    "No city data available for this period": "No city data available for this period",
    "No country data available for this period": "No country data available for this period",
    "No device data available": "No device data available",
    "No funnel data available": "No funnel data available",
    "No item data available": "No item data available",
    "No package data available": "No package data available",
    "No section data available for this period": "No section data available for this period",
    "No session data available": "No session data available",
    "No supply or demand data found. Add some ads to categories first.": "No supply or demand data found. Add some ads to categories first.",
    "No trend data available": "No trend data available",
    "No type data available": "No type data available",
    "Number of ads for each category type": "Number of ads for each category type",
    "Number of new ads posted each month over the past 12 months": "Number of new ads posted each month over the past 12 months",
    "Overall ratio": "Overall ratio",
    "Package renewal rate": "Package renewal rate",
    "Ratio of advertisements from local versus foreign advertisers per country": "Ratio of advertisements from local versus foreign advertisers per country",
    "Refresh": "Refresh",
    "Refresh data": "Refresh data",
    "Retry": "Retry",
    "Revenue": "Revenue",
    "Revenue breakdown": "Revenue breakdown",
    "Revenue by Ad Type / Section": "Revenue by Ad Type / Section",
    "Revenue by Category": "Revenue by Category",
    "Revenue by City": "Revenue by City",
    "Revenue by Country": "Revenue by Country",
    "Revenue by category": "Revenue by category",
    "Revenue by package": "Revenue by package",
    "Search category...": "Search category...",
    "Section": "Section",
    "Select a category from the sidebar to view its stats": "Select a category from the sidebar to view its stats",
    "Share": "Share",
    "Spending": "Spending",
    "Spending across ad packages": "Spending across ad packages",
    "Spending distribution across ad categories": "Spending distribution across ad categories",
    "Supply & Demand Report": "Supply & Demand Report",
    "Supply (Offer)": "Supply (Offer)",
    "Supply and demand matrix for all categories — sorted by gap size": "Supply and demand matrix for all categories — sorted by gap size",
    "Supply vs. Demand": "Supply vs. Demand",
    "Supply/Demand Ratio": "Supply/Demand Ratio",
    "Surplus Gaps": "Surplus Gaps",
    "Surplus only": "Surplus only",
    "Survival rate (30 days)": "Survival rate (30 days)",
    "Switching from free to paid": "Switching from free to paid",
    "The largest advertisers on the platform, ranked by total amount paid": "The largest advertisers on the platform, ranked by total amount paid",
    "The server took too long to respond. Please try again.": "The server took too long to respond. Please try again.",
    "Top 10 Most Reactive Items": "Top 10 Most Reactive Items",
    "Top 10 highest-spending advertisers": "Top 10 highest-spending advertisers",
    "Top Country": "Top Country",
    "Total Views": "Total Views",
    "Total revenue": "Total revenue",
    "User classification by account type": "User classification by account type",
    "User distribution by category": "User distribution by category",
    "User journey from open to deal": "User journey from open to deal",
    "Weekly active users": "Weekly active users",
    "ads": "ads",
    "iOS vs. Android usage ratio": "iOS vs. Android usage ratio",
    // ── Influencers / Ad Packages / Banned Keywords / Settings / Finance pages ──────────
    "AMOUNT": "AMOUNT",
    "About (Arabic)": "About (Arabic)",
    "About the influencer...": "About the influencer...",
    "Active Status": "Active Status",
    "Ad Package created successfully!": "Ad Package created successfully!",
    "Ad Package deleted successfully!": "Ad Package deleted successfully!",
    "Ad Package status updated successfully!": "Ad Package status updated successfully!",
    "Ad Package updated successfully!": "Ad Package updated successfully!",
    "Ad Payment": "Ad Payment",
    "Ad Refresh": "Ad Refresh",
    "Ad:": "Ad:",
    "Add All Keywords": "Add All Keywords",
    "Add Banned Keyword": "Add Banned Keyword",
    "Add Benefit": "Add Benefit",
    "Add Country Price Override": "Add Country Price Override",
    "Add Keyword": "Add Keyword",
    "Add New Ad Package": "Add New Ad Package",
    "Add New Influencer": "Add New Influencer",
    "All Types": "All Types",
    "Amount is required and must be greater than or equal to 0.": "Amount is required and must be greater than or equal to 0.",
    "Android Version": "Android Version",
    "Arabic": "Arabic",
    "At least one benefit is required.": "At least one benefit is required.",
    "At least one benefit with both English and Arabic text is required.": "At least one benefit with both English and Arabic text is required.",
    "Auto-calculated from Amount ÷ Duration, but can be manually adjusted": "Auto-calculated from Amount ÷ Duration, but can be manually adjusted",
    "Auto-calculated from Amount/Duration": "Auto-calculated from Amount/Duration",
    "BENEFITS COUNT": "BENEFITS COUNT",
    "Banned keywords found": "Banned keywords found",
    "Benefits": "Benefits",
    "Bulk Add": "Bulk Add",
    "Category Settings": "Category Settings",
    "Check Text": "Check Text",
    "Checking...": "Checking...",
    "Comma or newline-separated. Duplicates skipped.": "Comma or newline-separated. Duplicates skipped.",
    "Cover Image": "Cover Image",
    "DAILY RATE": "DAILY RATE",
    "DURATION": "DURATION",
    "Daily Rate ($/day)": "Daily Rate ($/day)",
    "Default Amount ($)": "Default Amount ($)",
    "Default price:": "Default price:",
    "Duration (Days)": "Duration (Days)",
    "Duration is required and must be at least 1 day.": "Duration is required and must be at least 1 day.",
    "Edit Ad Package": "Edit Ad Package",
    "Edit Influencer": "Edit Influencer",
    "English": "English",
    "Enter Ad Refresh": "Enter Ad Refresh",
    "Enter Amount": "Enter Amount",
    "Enter Duration": "Enter Duration",
    "Enter Email": "Enter Email",
    "Enter Free Days": "Enter Free Days",
    "Enter Location": "Enter Location",
    "Enter Name": "Enter Name",
    "Enter Name in Arabic": "Enter Name in Arabic",
    "Enter Package Title": "Enter Package Title",
    "Enter Package Title in Arabic": "Enter Package Title in Arabic",
    "Enter Phone": "Enter Phone",
    "Enter Title": "Enter Title",
    "Enter Title in Arabic": "Enter Title in Arabic",
    "Enter benefit in Arabic": "Enter benefit in Arabic",
    "Enter benefit in English": "Enter benefit in English",
    "Enter reason for refund…": "Enter reason for refund…",
    "Enter text to check": "Enter text to check",
    "Error loading ad packages": "Error loading ad packages",
    "Error loading banned keywords.": "Error loading banned keywords.",
    "Error loading influencers": "Error loading influencers",
    "Exporting…": "Exporting…",
    "FREE DAYS": "FREE DAYS",
    "Facebook": "Facebook",
    "Facebook URL": "Facebook URL",
    "Failed to add keyword.": "Failed to add keyword.",
    "Failed to add keywords.": "Failed to add keywords.",
    "Failed to check text.": "Failed to check text.",
    "Failed to create ad package. Please try again.": "Failed to create ad package. Please try again.",
    "Failed to create influencer. Please try again.": "Failed to create influencer. Please try again.",
    "Failed to delete ad package. Please try again.": "Failed to delete ad package. Please try again.",
    "Failed to delete influencer. Please try again.": "Failed to delete influencer. Please try again.",
    "Failed to export. Please try again.": "Failed to export. Please try again.",
    "Failed to process refund.": "Failed to process refund.",
    "Failed to remove keyword.": "Failed to remove keyword.",
    "Failed to save pricing.": "Failed to save pricing.",
    "Failed to update ad package status. Please try again.": "Failed to update ad package status. Please try again.",
    "Failed to update ad package. Please try again.": "Failed to update ad package. Please try again.",
    "Failed to update influencer. Please try again.": "Failed to update influencer. Please try again.",
    "Failed to update settings.": "Failed to update settings.",
    "Fesilah Market": "Fesilah Market",
    "Free Days (Bonus)": "Free Days (Bonus)",
    "General": "General",
    "Hide": "Hide",
    "IOS Version": "IOS Version",
    "Influencer created successfully!": "Influencer created successfully!",
    "Influencer deleted successfully!": "Influencer deleted successfully!",
    "Influencer updated successfully!": "Influencer updated successfully!",
    "Instagram": "Instagram",
    "Instagram URL": "Instagram URL",
    "Keyword": "Keyword",
    "Keyword banned successfully.": "Keyword banned successfully.",
    "Keyword removed.": "Keyword removed.",
    "Keywords": "Keywords",
    "Keywords added.": "Keywords added.",
    "LOCATION": "LOCATION",
    "Live": "Live",
    "Location (Arabic)": "Location (Arabic)",
    "Monthly Revenue (Last 6 Months)": "Monthly Revenue (Last 6 Months)",
    "NAME": "NAME",
    "NAME ARABIC": "NAME ARABIC",
    "Name (Arabic) is required": "Name (Arabic) is required",
    "Name is required": "Name is required",
    "No ad packages found": "No ad packages found",
    "No banned keywords yet.": "No banned keywords yet.",
    "No country-specific prices yet. All users will see the default price.": "No country-specific prices yet. All users will see the default price.",
    "No influencers found": "No influencers found",
    "No transactions found": "No transactions found",
    "Paste an ad title or description here to check for banned words...": "Paste an ad title or description here to check for banned words...",
    "Pay:": "Pay:",
    "Payment": "Payment",
    "Payment Mode": "Payment Mode",
    "Please select a country.": "Please select a country.",
    "Popup Message": "Popup Message",
    "Popup Message Arabic": "Popup Message Arabic",
    "Price ($)": "Price ($)",
    "Pricing by Country": "Pricing by Country",
    "Pricing saved successfully!": "Pricing saved successfully!",
    "Process Refund": "Process Refund",
    "Profile Icon": "Profile Icon",
    "RECOMMENDED": "RECOMMENDED",
    "ROLE": "ROLE",
    "Recommended": "Recommended",
    "Recommended Package": "Recommended Package",
    "Refund": "Refund",
    "Refund Reason (optional)": "Refund Reason (optional)",
    "Refund processed successfully.": "Refund processed successfully.",
    "Refunding": "Refunding",
    "Remove": "Remove",
    "Role": "Role",
    "Role (Arabic)": "Role (Arabic)",
    "Save Pricing": "Save Pricing",
    "Save Settings": "Save Settings",
    "Saving…": "Saving…",
    "Search Ad Package Title..": "Search Ad Package Title..",
    "Search Influencer Name..": "Search Influencer Name..",
    "Search keywords...": "Search keywords...",
    "Search user, email…": "Search user, email…",
    "Select country…": "Select country…",
    "Settings updated successfully!": "Settings updated successfully!",
    "Show": "Show",
    "Single Add": "Single Add",
    "Snapchat": "Snapchat",
    "Snapchat URL": "Snapchat URL",
    "Social Media Links": "Social Media Links",
    "Status updated successfully!": "Status updated successfully!",
    "Stored lowercase. Checked in ad title & description.": "Stored lowercase. Checked in ad title & description.",
    "Subscription": "Subscription",
    "Test": "Test",
    "Test Text": "Test Text",
    "Text is clean": "Text is clean",
    "Threads": "Threads",
    "Threads URL": "Threads URL",
    "TikTok": "TikTok",
    "TikTok URL": "TikTok URL",
    "Total Refunded": "Total Refunded",
    "Update Settings": "Update Settings",
    "Update failed": "Update failed",
    "Used when no country-specific price is set": "Used when no country-specific price is set",
    "Version Popup Title": "Version Popup Title",
    "Version Title Arabic": "Version Title Arabic",
    "Voucher": "Voucher",
    "Wallet Credit": "Wallet Credit",
    "Wallet Debit": "Wallet Debit",
    "Wallet Transactions": "Wallet Transactions",
    "YouTube": "YouTube",
    "YouTube URL": "YouTube URL",
    "applied when no country-specific price is set.": "applied when no country-specific price is set.",
    "day": "day",
    "e.g. Farmer, Expert": "e.g. Farmer, Expert",
    "e.g. spam, fake, scam": "e.g. spam, fake, scam",
    "e.g. مزارع، خبير": "e.g. مزارع، خبير",
    "for": "for",
    "keyword banned": "keyword banned",
    "keywords banned": "keywords banned",
    "pending": "pending",
    "records": "records",
    "refunds": "refunds",
    "transactions": "transactions",
    "transactions · incl. wallet": "transactions · incl. wallet",
    "vs. Default": "vs. Default",
    "أدخل الموقع": "أدخل الموقع",
    "نبذة عن المؤثر...": "نبذة عن المؤثر...",
    "● Live payments are active": "● Live payments are active",
    "● Test mode — no real charges": "● Test mode — no real charges",
    // ── Reviews / Promo Codes / Ad Categories / Ad Types pages ──────────
    "Activated By": "Activated By",
    "Activation Date": "Activation Date",
    "Ad": "Ad",
    "Ad Category created successfully!": "Ad Category created successfully!",
    "Ad Category deleted successfully!": "Ad Category deleted successfully!",
    "Ad Category status updated successfully!": "Ad Category status updated successfully!",
    "Ad Category updated successfully!": "Ad Category updated successfully!",
    "Ad ID": "Ad ID",
    "Add Another Type": "Add Another Type",
    "Add Category Type": "Add Category Type",
    "Add Custom Field": "Add Custom Field",
    "Add Custom Filter": "Add Custom Filter",
    "Add New": "Add New",
    "Add New Ad Category": "Add New Ad Category",
    "Add New Subcategory": "Add New Subcategory",
    "Add Option": "Add Option",
    "Add Promo Code": "Add Promo Code",
    "All fields (English & Arabic) are required for all types.": "All fields (English & Arabic) are required for all types.",
    "All options must have both English and Arabic values": "All options must have both English and Arabic values",
    "All options must have both English and Arabic values!": "All options must have both English and Arabic values!",
    "Any date": "Any date",
    "Applicable To": "Applicable To",
    "Approve": "Approve",
    "Approve Review": "Approve Review",
    "Arabic Label": "Arabic Label",
    "Are you sure you want to delete this category type?": "Are you sure you want to delete this category type?",
    "Are you sure you want to delete this custom field?": "Are you sure you want to delete this custom field?",
    "Are you sure you want to delete this custom filter?": "Are you sure you want to delete this custom filter?",
    "Are you sure you want to mark this review as": "Are you sure you want to mark this review as",
    "Assigned Users": "Assigned Users",
    "At least one user must be selected.": "At least one user must be selected.",
    "Avg. Discount / Use": "Avg. Discount / Use",
    "Back to Batches": "Back to Batches",
    "Back to Categories": "Back to Categories",
    "Back to List": "Back to List",
    "Batch Name": "Batch Name",
    "Batch Name (Arabic)": "Batch Name (Arabic)",
    "Batch Vouchers": "Batch Vouchers",
    "Batch created successfully!": "Batch created successfully!",
    "Batch updated successfully!": "Batch updated successfully!",
    "Before today": "Before today",
    "Card Value": "Card Value",
    "Category Icon": "Category Icon",
    "Category Types": "Category Types",
    "Category Types for:": "Category Types for:",
    "Category type created successfully": "Category type created successfully",
    "Category type deleted successfully": "Category type deleted successfully",
    "Category type updated successfully": "Category type updated successfully",
    "Checkbox": "Checkbox",
    "City list": "City list",
    "Code": "Code",
    "Comment": "Comment",
    "Country list": "Country list",
    "Coupon Code": "Coupon Code",
    "Coupon Type": "Coupon Type",
    "Currency list": "Currency list",
    "Custom Fields": "Custom Fields",
    "Custom Fields for:": "Custom Fields for:",
    "Custom Filters": "Custom Filters",
    "Custom Filters for:": "Custom Filters for:",
    "Custom field created successfully!": "Custom field created successfully!",
    "Custom field deleted successfully!": "Custom field deleted successfully!",
    "Custom field updated successfully!": "Custom field updated successfully!",
    "Custom filter created successfully": "Custom filter created successfully",
    "Custom filter deleted successfully": "Custom filter deleted successfully",
    "Custom filter updated successfully": "Custom filter updated successfully",
    "Customer": "Customer",
    "Date Created": "Date Created",
    "Delete Category Type": "Delete Category Type",
    "Delete Custom Field": "Delete Custom Field",
    "Delete Custom Filter": "Delete Custom Filter",
    "Demand": "Demand",
    "Description (AR)": "Description (AR)",
    "Description (EN)": "Description (EN)",
    "Description (English)": "Description (English)",
    "Discount": "Discount",
    "Discount Type": "Discount Type",
    "Discount Value": "Discount Value",
    "Dropdown (Multiple)": "Dropdown (Multiple)",
    "Dropdown (Single)": "Dropdown (Single)",
    "Dropdown Multiple": "Dropdown Multiple",
    "Dropdown Single": "Dropdown Single",
    "Edit Ad Category": "Edit Ad Category",
    "Edit Batch": "Edit Batch",
    "Edit Batch Details": "Edit Batch Details",
    "Edit Category Type": "Edit Category Type",
    "Edit Custom Field": "Edit Custom Field",
    "Edit Custom Filter": "Edit Custom Filter",
    "Edit Promo Code": "Edit Promo Code",
    "Edit Promo Code Details": "Edit Promo Code Details",
    "English Label": "English Label",
    "Enter Category Description": "Enter Category Description",
    "Enter Category Description in Arabic": "Enter Category Description in Arabic",
    "Enter description in Arabic": "Enter description in Arabic",
    "Enter description in English": "Enter description in English",
    "Enter field name in Arabic": "Enter field name in Arabic",
    "Enter field name in English": "Enter field name in English",
    "Enter filter name in Arabic": "Enter filter name in Arabic",
    "Enter filter name in English": "Enter filter name in English",
    "Enter title in Arabic": "Enter title in Arabic",
    "Enter title in English": "Enter title in English",
    "Error loading ad categories": "Error loading ad categories",
    "Error loading promo codes": "Error loading promo codes",
    "Error loading review details": "Error loading review details",
    "Error loading vouchers": "Error loading vouchers",
    "Expired At": "Expired At",
    "Expiry": "Expiry",
    "Expiry Date": "Expiry Date",
    "Expiry Type": "Expiry Type",
    "Export to Excel": "Export to Excel",
    "FEATURES COUNT": "FEATURES COUNT",
    "Failed to create ad category. Please try again.": "Failed to create ad category. Please try again.",
    "Failed to delete ad category. Please try again.": "Failed to delete ad category. Please try again.",
    "Failed to delete category type. Please try again.": "Failed to delete category type. Please try again.",
    "Failed to delete custom field. Please try again.": "Failed to delete custom field. Please try again.",
    "Failed to delete custom filter. Please try again.": "Failed to delete custom filter. Please try again.",
    "Failed to delete promo code.": "Failed to delete promo code.",
    "Failed to delete strategic ad type": "Failed to delete strategic ad type",
    "Failed to save batch. Please try again.": "Failed to save batch. Please try again.",
    "Failed to save category type. Please try again.": "Failed to save category type. Please try again.",
    "Failed to save custom field. Please try again.": "Failed to save custom field. Please try again.",
    "Failed to save custom filter. Please try again.": "Failed to save custom filter. Please try again.",
    "Failed to save promo code.": "Failed to save promo code.",
    "Failed to save strategic ad types. Please try again.": "Failed to save strategic ad types. Please try again.",
    "Failed to update ad category status. Please try again.": "Failed to update ad category status. Please try again.",
    "Failed to update ad category. Please try again.": "Failed to update ad category. Please try again.",
    "Failed to update review status. Please try again.": "Failed to update review status. Please try again.",
    "Failed to update status. Please try again.": "Failed to update status. Please try again.",
    "Field Key": "Field Key",
    "Field Name (AR)": "Field Name (AR)",
    "Field Name (EN)": "Field Name (EN)",
    "Field Type": "Field Type",
    "Field name (English and Arabic) is required!": "Field name (English and Arabic) is required!",
    "File (Multiple)": "File (Multiple)",
    "File (Single)": "File (Single)",
    "Filter Key": "Filter Key",
    "Filter Name (AR)": "Filter Name (AR)",
    "Filter Name (Arabic)": "Filter Name (Arabic)",
    "Filter Name (EN)": "Filter Name (EN)",
    "Filter Name (English)": "Filter Name (English)",
    "Filter Type": "Filter Type",
    "Filter name (English and Arabic) is required": "Filter name (English and Arabic) is required",
    "Fixed": "Fixed",
    "Fixed Amount": "Fixed Amount",
    "For Employer": "For Employer",
    "For Job Seeker": "For Job Seeker",
    "Future only": "Future only",
    "ICON": "ICON",
    "Icon": "Icon",
    "Is Required?": "Is Required?",
    "Key": "Key",
    "Leave empty for no cap": "Leave empty for no cap",
    "Leave empty for no minimum": "Leave empty for no minimum",
    "Leave empty for unlimited": "Leave empty for unlimited",
    "Listing Type": "Listing Type",
    "Manage Strategic Ad Types": "Manage Strategic Ad Types",
    "Manage custom fields for this ad category": "Manage custom fields for this ad category",
    "Manage custom filters for this ad category": "Manage custom filters for this ad category",
    "Manage types for this ad category": "Manage types for this ad category",
    "Max": "Max",
    "Max Characters": "Max Characters",
    "Max Discount": "Max Discount",
    "Max Value": "Max Value",
    "Max characters cannot be less than min characters": "Max characters cannot be less than min characters",
    "Max times a single customer can use this code.": "Max times a single customer can use this code.",
    "Max value cannot be less than min value": "Max value cannot be less than min value",
    "Maximum Discount Amount": "Maximum Discount Amount",
    "Maximum Usage Count": "Maximum Usage Count",
    "Min": "Min",
    "Min Characters": "Min Characters",
    "Min Order": "Min Order",
    "Min Value": "Min Value",
    "Minimum Order Amount": "Minimum Order Amount",
    "Must be unique. Letters and numbers only.": "Must be unique. Letters and numbers only.",
    "New": "New",
    "New Batch Details": "New Batch Details",
    "New Promo Code Details": "New Promo Code Details",
    "New Users": "New Users",
    "No ad categories found": "No ad categories found",
    "No category types found. Click \"Add Category Type\" to create one.": "No category types found. Click \"Add Category Type\" to create one.",
    "No comment provided": "No comment provided",
    "No custom fields found. Click \"Add Custom Field\" to create one.": "No custom fields found. Click \"Add Custom Field\" to create one.",
    "No custom filters found. Click \"Add Custom Filter\" to create one.": "No custom filters found. Click \"Add Custom Filter\" to create one.",
    "No max characters": "No max characters",
    "No max value": "No max value",
    "No min characters": "No min characters",
    "No min value": "No min value",
    "No promo codes found": "No promo codes found",
    "No redemptions yet": "No redemptions yet",
    "No restriction": "No restriction",
    "No reviews found": "No reviews found",
    "No vouchers found": "No vouchers found",
    "Number": "Number",
    "Off": "Off",
    "Old Users": "Old Users",
    "Option (AR)": "Option (AR)",
    "Option (EN)": "Option (EN)",
    "Options": "Options",
    "Order / Ref": "Order / Ref",
    "Parent Category": "Parent Category",
    "Past only": "Past only",
    "Percentage": "Percentage",
    "Please add at least one option for dropdown/radio fields!": "Please add at least one option for dropdown/radio fields!",
    "Please add at least one option for dropdown/radio/checkbox filters": "Please add at least one option for dropdown/radio/checkbox filters",
    "Posted On": "Posted On",
    "Promo Code": "Promo Code",
    "Promo Code Details": "Promo Code Details",
    "Promo Details": "Promo Details",
    "Promo code created successfully!": "Promo code created successfully!",
    "Promo code deleted successfully!": "Promo code deleted successfully!",
    "Promo code not found.": "Promo code not found.",
    "Promo code updated successfully!": "Promo code updated successfully!",
    "Quantity cannot be changed after creation.": "Quantity cannot be changed after creation.",
    "Radio": "Radio",
    "Range": "Range",
    "Redemption History": "Redemption History",
    "Redemption Rate": "Redemption Rate",
    "Reject": "Reject",
    "Reject Review": "Reject Review",
    "Remove Type": "Remove Type",
    "Required": "Required",
    "Review Content": "Review Content",
    "Review Details": "Review Details",
    "Review not found": "Review not found",
    "Review status updated successfully!": "Review status updated successfully!",
    "Reviews": "Reviews",
    "Save Changes": "Save Changes",
    "Search Reviews...": "Search Reviews...",
    "Search Voucher ID...": "Search Voucher ID...",
    "Search by title or code...": "Search by title or code...",
    "Search users by name, email or phone...": "Search users by name, email or phone...",
    "Select Key": "Select Key",
    "Select Users": "Select Users",
    "Select expiry date": "Select expiry date",
    "Stars": "Stars",
    "Status updated successfully": "Status updated successfully",
    "Strategic Type": "Strategic Type",
    "Strategic ad type deleted successfully": "Strategic ad type deleted successfully",
    "Strategic ad types saved successfully!": "Strategic ad types saved successfully!",
    "Subcategories": "Subcategories",
    "Subcategories of": "Subcategories of",
    "Subcategory": "Subcategory",
    "Supply": "Supply",
    "TITLE ARABIC": "TITLE ARABIC",
    "Text": "Text",
    "Textarea": "Textarea",
    "Title (AR)": "Title (AR)",
    "Title (EN)": "Title (EN)",
    "Title (English and Arabic) is required": "Title (English and Arabic) is required",
    "Today and onwards": "Today and onwards",
    "Total Activated": "Total Activated",
    "Total Discount Given": "Total Discount Given",
    "Total Issued": "Total Issued",
    "Total Redeemed Value": "Total Redeemed Value",
    "Total Redemptions": "Total Redemptions",
    "Type": "Type",
    "Type Description": "Type Description",
    "Type Description (Arabic)": "Type Description (Arabic)",
    "Type Title": "Type Title",
    "Type Title (Arabic)": "Type Title (Arabic)",
    "Type at least 2 characters to search": "Type at least 2 characters to search",
    "Types": "Types",
    "Unique Customers": "Unique Customers",
    "Unlimited": "Unlimited",
    "Update Status": "Update Status",
    "Usage / Customer": "Usage / Customer",
    "Usage Count": "Usage Count",
    "Usage Limit Per Customer": "Usage Limit Per Customer",
    "Used": "Used",
    "Used At": "Used At",
    "User ID": "User ID",
    "Value cannot be changed after creation.": "Value cannot be changed after creation.",
    "Voucher Code": "Voucher Code",
    "Voucher ID": "Voucher ID",
    "Vouchers": "Vouchers",
    "Yes,": "Yes,",
    "You want to delete this strategic ad type?": "You want to delete this strategic ad type?",
    "active": "active",
    "e.g. Dubai Expo 2025": "e.g. Dubai Expo 2025",
    "e.g. Summer Sale": "e.g. Summer Sale",
    "e.g. تخفيض الصيف": "e.g. تخفيض الصيف",
    "fixed": "fixed",
    "total uses": "total uses",
    "uses max": "uses max",
    // ── Trade / Ads / Advertisers / Fesilah Cards pages ──────────
    "% of Total Visits": "% of Total Visits",
    "1–5 minutes": "1–5 minutes",
    "ACTIONS": "ACTIONS",
    "AD ID": "AD ID",
    "Account Type Breakdown": "Account Type Breakdown",
    "Accounts": "Accounts",
    "Activation Rate": "Activation Rate",
    "Active Ads": "Active Ads",
    "Active Campaigns": "Active Campaigns",
    "Active Cards": "Active Cards",
    "Active Countries": "Active Countries",
    "Active Users": "Active Users",
    "Ad Revenue": "Ad Revenue",
    "Ad Title": "Ad Title",
    "Ad deleted successfully!": "Ad deleted successfully!",
    "Add New Batch": "Add New Batch",
    "Ads Published": "Ads Published",
    "Ads published per month": "Ads published per month",
    "Advertiser": "Advertiser",
    "All Ads": "All Ads",
    "All Categories": "All Categories",
    "All Methods": "All Methods",
    "All Status": "All Status",
    "Amount": "Amount",
    "Apple Pay": "Apple Pay",
    "Apply": "Apply",
    "Applying…": "Applying…",
    "Average CTR": "Average CTR",
    "Average time per visit": "Average time per visit",
    "Avg. CTR": "Avg. CTR",
    "Avg. Session": "Avg. Session",
    "Avg. Spend / Advertiser": "Avg. Spend / Advertiser",
    "Avg. Time Spent": "Avg. Time Spent",
    "Batch ID": "Batch ID",
    "Batch deleted successfully!": "Batch deleted successfully!",
    "Bulk action applied!": "Bulk action applied!",
    "Bulk action failed. Please try again.": "Bulk action failed. Please try again.",
    "CATEGORY": "CATEGORY",
    "CITY": "CITY",
    "CLICKS": "CLICKS",
    "COUNTRY": "COUNTRY",
    "CREATED DATE": "CREATED DATE",
    "Card": "Card",
    "Change Status…": "Change Status…",
    "Clicks": "Clicks",
    "Completed": "Completed",
    "Completed Ads": "Completed Ads",
    "Count": "Count",
    "Country / City": "Country / City",
    "Currently active": "Currently active",
    "DAU": "DAU",
    "Daily Active Users": "Daily Active Users",
    "Date": "Date",
    "Deselect All": "Deselect All",
    "Deselect all on this page": "Deselect all on this page",
    "Distribution of ads per category": "Distribution of ads per category",
    "Distribution of registered users by account type": "Distribution of registered users by account type",
    "Draft": "Draft",
    "Error loading ads": "Error loading ads",
    "Error loading batches": "Error loading batches",
    "Expired Cards": "Expired Cards",
    "Failed": "Failed",
    "Failed to delete ad. Please try again.": "Failed to delete ad. Please try again.",
    "Failed to delete batch. Please try again.": "Failed to delete batch. Please try again.",
    "Fesilah Wallet": "Fesilah Wallet",
    "Free Ads": "Free Ads",
    "Free → Paid Rate": "Free → Paid Rate",
    "Highest performing ads by views": "Highest performing ads by views",
    "Inactive / Unused Cards": "Inactive / Unused Cards",
    "Joined": "Joined",
    "LANGUAGE": "LANGUAGE",
    "MAU": "MAU",
    "Manual": "Manual",
    "Monthly Active Users": "Monthly Active Users",
    "Monthly Ads": "Monthly Ads",
    "Most Active Sections & Pages": "Most Active Sections & Pages",
    "Most active cities by user count": "Most active cities by user count",
    "No ads found": "No ads found",
    "No advertisers found": "No advertisers found",
    "No batches found": "No batches found",
    "No category data available": "No category data available",
    "No city data available": "No city data available",
    "No country data available": "No country data available",
    "No data": "No data",
    "No page visit data available yet": "No page visit data available yet",
    "No payment records found": "No payment records found",
    "No performance data available for the selected period": "No performance data available for the selected period",
    "No previous month data": "No previous month data",
    "No trend data yet": "No trend data yet",
    "No trending ads data available yet": "No trending ads data available yet",
    "Online Now": "Online Now",
    "Over 10 min": "Over 10 min",
    "PAID AMOUNT": "PAID AMOUNT",
    "Package Renewal Rate": "Package Renewal Rate",
    "Payment Date Range": "Payment Date Range",
    "Payment Records": "Payment Records",
    "Peak Activity Hours": "Peak Activity Hours",
    "Pending Ads": "Pending Ads",
    "Performance": "Performance",
    "Performance report for the selected period": "Performance report for the selected period",
    "Period": "Period",
    "Please select a status to apply.": "Please select a status to apply.",
    "Please select at least one ad.": "Please select at least one ad.",
    "Posted By": "Posted By",
    "Quantity": "Quantity",
    "Ranked by visit volume with average time spent": "Ranked by visit volume with average time spent",
    "Refunded": "Refunded",
    "Rejected": "Rejected",
    "Rejected Ads": "Rejected Ads",
    "Rejection reason (optional)": "Rejection reason (optional)",
    "Retention Rate": "Retention Rate",
    "STATUS": "STATUS",
    "Search Ad Title..": "Search Ad Title..",
    "Search Batch Name/ID...": "Search Batch Name/ID...",
    "Search advertiser…": "Search advertiser…",
    "Search name, email…": "Search name, email…",
    "Section / Page": "Section / Page",
    "Select all on this page": "Select all on this page",
    "Session Duration": "Session Duration",
    "Shares": "Shares",
    "Strategic Ads": "Strategic Ads",
    "Stripe": "Stripe",
    "TITLE": "TITLE",
    "TYPE": "TYPE",
    "This Month": "This Month",
    "This Week": "This Week",
    "This month vs last": "This month vs last",
    "This week vs last": "This week vs last",
    "Today": "Today",
    "Today vs yesterday": "Today vs yesterday",
    "Today's Ads": "Today's Ads",
    "Top 10 Cities": "Top 10 Cities",
    "Top 10 Countries": "Top 10 Countries",
    "Top 10 Highest-Spending Advertisers": "Top 10 Highest-Spending Advertisers",
    "Top Categories by Ads": "Top Categories by Ads",
    "Top Trending Ads": "Top Trending Ads",
    "Total Ad Revenue (This Year)": "Total Ad Revenue (This Year)",
    "Total Ads": "Total Ads",
    "Total Advertisers": "Total Advertisers",
    "Total Cards Issued": "Total Cards Issued",
    "Total Packages": "Total Packages",
    "Total Paid": "Total Paid",
    "Total Revenue": "Total Revenue",
    "Total Spending": "Total Spending",
    "Total Users": "Total Users",
    "Total:": "Total:",
    "Trade Dashboard": "Trade Dashboard",
    "USER": "USER",
    "Under 1 min": "Under 1 min",
    "Unique users per hour of day": "Unique users per hour of day",
    "Unique users who opened the app": "Unique users who opened the app",
    "Users by country of registration": "Users by country of registration",
    "Users who returned this month": "Users who returned this month",
    "VIEWS": "VIEWS",
    "Value": "Value",
    "View Details": "View Details",
    "View Vouchers": "View Vouchers",
    "Views": "Views",
    "WAU": "WAU",
    "Weekly Active Users": "Weekly Active Users",
    "ad payment records": "ad payment records",
    "ad selected": "ad selected",
    "ads selected": "ads selected",
    "is peak": "is peak",
    "online now": "online now",
    "per visit": "per visit",
    "this month": "this month",
    "total": "total",
    "total sessions": "total sessions",
    "unique advertisers": "unique advertisers",
    "unique users who posted at least 1 ad": "unique users who posted at least 1 ad",
    "visits": "visits",
    "vs last month": "vs last month",
    "vs last week": "vs last week",
    "vs yesterday": "vs yesterday",
    // ── System Users / Roles / Permissions / Activity Logs / Account ──
    "Add New User": "Add New User",
    "Search Name or Email..": "Search Name or Email..",
    "Error loading system users": "Error loading system users",
    "system-users": "system-users",
    "Edit System User": "Edit System User",
    "Add New System User": "Add New System User",
    "User Name": "User Name",
    "Enter System User Name": "Enter System User Name",
    "User Email": "User Email",
    "Enter System User Email": "Enter System User Email",
    "Leave blank to keep current password": "Leave blank to keep current password",
    "Enter System User Password": "Enter System User Password",
    "User Phone No": "User Phone No",
    "Enter System User Phone": "Enter System User Phone",
    "User Role": "User Role",
    "Select Role": "Select Role",
    "Add New Role": "Add New Role",
    "Search Role Name..": "Search Role Name..",
    "Error loading roles": "Error loading roles",
    "roles": "roles",
    "Edit Role": "Edit Role",
    "Role Name": "Role Name",
    "Enter Role Name": "Enter Role Name",
    "Role Permissions": "Role Permissions",
    "Role:": "Role:",
    "Are you sure you want to update permissions for this role?": "Are you sure you want to update permissions for this role?",
    "Update Permissions": "Update Permissions",
    "Permissions": "Permissions",
    "Search Permission Name..": "Search Permission Name..",
    "Error loading permissions": "Error loading permissions",
    "permissions": "permissions",
    "All Modules": "All Modules",
    "All Actions": "All Actions",
    "Status Update": "Status Update",
    "Clear Filters": "Clear Filters",
    "Module": "Module",
    "Performed By": "Performed By",
    "Ref ID": "Ref ID",
    "View": "View",
    "No activity logs found": "No activity logs found",
    "Error loading activity logs": "Error loading activity logs",
    "Before": "Before",
    "After": "After",
    "Search user or module...": "Search user or module...",
    "Date range (YYYY-MM-DD - YYYY-MM-DD)": "Date range (YYYY-MM-DD - YYYY-MM-DD)",
    "Change Email or Password": "Change Email or Password",
    "Update Email": "Update Email",
    "Old(Current) Password": "Old(Current) Password",
    "Enter Your Old Password": "Enter Your Old Password",
    "New Password": "New Password",
    "Enter New Password": "Enter New Password",
    "Confirm Password": "Confirm Password",
    "Enter Confirm Password": "Enter Confirm Password",
    "Change Password": "Change Password",
    // ── Ad Details ─────────────────────────────────────────────
    "Ad Details": "Ad Details",
    "Draft — Status locked": "Draft — Status locked",
    "Processing…": "Processing…",
    "Approved": "Approved",
    "Paused": "Paused",
    "Basic Information": "Basic Information",
    "Sub Category": "Sub Category",
    "Category Type": "Category Type",
    "Ad Destination": "Ad Destination",
    "CTA Button Text": "CTA Button Text",
    "Target Ad": "Target Ad",
    "Payment Method:": "Payment Method:",
    "Transaction ID:": "Transaction ID:",
    "Pay Amount:": "Pay Amount:",
    "Same Content": "Same Content",
    "image(s)": "image(s)",
    "field(s)": "field(s)",
    "Analytics": "Analytics",
    "Ad Performance": "Ad Performance",
    "Total Clicks": "Total Clicks",
    "Reach": "Reach",
    "Outbound Clicks": "Outbound Clicks",
    "Ad Duration": "Ad Duration",
    "Remaining Duration": "Remaining Duration",
    "Bounce Rate": "Bounce Rate",
    "Repeat Visitors": "Repeat Visitors",
    "Engagement Metrics": "Engagement Metrics",
    "Favorites": "Favorites",
    "Comments": "Comments",
    "Engagement Score": "Engagement Score",
    "Scroll Depth": "Scroll Depth",
    "Average Time on Ad": "Average Time on Ad",
    "Conversion & Contact": "Conversion & Contact",
    "Messages": "Messages",
    "Cost Per Message": "Cost Per Message",
    "Conversion Rate": "Conversion Rate",
    "Financial Metrics": "Financial Metrics",
    "Average CPC": "Average CPC",
    "Average CPM": "Average CPM",
    "Cost Per Contact": "Cost Per Contact",
    "Click Through Rate": "Click Through Rate",
    "Audience and Reach": "Audience and Reach",
    "Top Locations": "Top Locations",
    "Traffic Sources": "Traffic Sources",
    "No analytics data available.": "No analytics data available.",
    "Advertiser Details": "Advertiser Details",
    "View advertiser profile": "View advertiser profile",
    "country/countries": "country/countries",
    "city/cities": "city/cities",
    "Performance Overview": "Performance Overview",
    "Views, clicks, reach, shares & engagement": "Views, clicks, reach, shares & engagement",
    "Engagement Breakdown": "Engagement Breakdown",
    "Shares, comments & favorites": "Shares, comments & favorites",
    "No engagement data yet": "No engagement data yet",
    "Views & Clicks Over Time": "Views & Clicks Over Time",
    "Daily/weekly activity timeline": "Daily/weekly activity timeline",
    "Audience by Country": "Audience by Country",
    "Views and clicks per user country": "Views and clicks per user country",
    "Rate Metrics": "Rate Metrics",
    "CTR, bounce rate, scroll depth & conversion": "CTR, bounce rate, scroll depth & conversion",
    "Reject Ad": "Reject Ad",
    "Rejection Reason": "Rejection Reason",
    "Enter rejection reason (optional)…": "Enter rejection reason (optional)…",
    "Do you want to change the status to": "Do you want to change the status to",
    "Yes, update it!": "Yes, update it!",
    "Processing Rejection…": "Processing Rejection…",
    "Updating Status…": "Updating Status…",
    "Sending notification and processing refund. Please wait…": "Sending notification and processing refund. Please wait…",
    "Please wait…": "Please wait…",
    "Updated!": "Updated!",
    "Ad status has been updated to": "Ad status has been updated to",
    "Error!": "Error!",
    "Failed to update ad status.": "Failed to update ad status.",
    "Error loading ad details": "Error loading ad details",
    "Ad not found": "Ad not found",
    // ── Reports & Complaints (moderation) ──────────────────────
    "Reports & Complaints": "Reports & Complaints",
    "Pending Review": "Pending Review",
    "Reviewed": "Reviewed",
    "Resolved": "Resolved",
    "Dismissed": "Dismissed",
    "reviewed": "Reviewed",
    "resolved": "Resolved",
    "dismissed": "Dismissed",
    "Search reporter, ad, reason...": "Search reporter, ad, reason...",
    "All Report Types": "All Report Types",
    "Ad Reports": "Ad Reports",
    "User Reports": "User Reports",
    "Ad Report": "Ad Report",
    "User Report": "User Report",
    "Reporter": "Reporter",
    "Reported": "Reported",
    "Reported User": "Reported User",
    "Reported Ad": "Reported Ad",
    "Action Taken": "Action Taken",
    "Submitted": "Submitted",
    "No reports found": "No reports found",
    "Report not found": "Report not found",
    "Report Details": "Report Details",
    "Reported User History": "Reported User History",
    "Reports against their ads": "Reports against their ads",
    "Reports against them": "Reports against them",
    "Recorded violations": "Recorded violations",
    "Review & Decision": "Review & Decision",
    "Decision": "Decision",
    "Reviewed — looked at, no decision yet": "Reviewed — looked at, no decision yet",
    "Accept report — valid, action taken": "Accept report — valid, action taken",
    "Reject report — invalid or unfounded": "Reject report — invalid or unfounded",
    "No action — record decision only": "No action — record decision only",
    "Issue warning to the reported user": "Issue warning to the reported user",
    "Suspend the reported account": "Suspend the reported account",
    "Remove the reported ad": "Remove the reported ad",
    "No Action": "No Action",
    "Warning Issued": "Warning Issued",
    "Account Suspended": "Account Suspended",
    "Ad Removed": "Ad Removed",
    "Admin Note": "Admin Note",
    "Why was this decision made? (visible to admins only)": "Why was this decision made? (visible to admins only)",
    "Submit Decision": "Submit Decision",
    "Submitting...": "Submitting...",
    "Confirm Review Decision": "Confirm Review Decision",
    "Yes, submit": "Yes, submit",
    "Report reviewed successfully!": "Report reviewed successfully!",
    "Failed to review report. Please try again.": "Failed to review report. Please try again.",
    "You do not have permission to review reports.": "You do not have permission to review reports.",
    "You do not have permission to take action on reports.": "You do not have permission to take action on reports.",
    "Last reviewed by": "Last reviewed by",
    "Back to Reports": "Back to Reports",
    "Evidence": "Evidence",
    "Unknown User": "Unknown User",
    "Review": "Review",
    "AFFECTED CONTENT": "AFFECTED CONTENT",
    "Accepted: JPG, PNG, PDF, DOC, DOCX (max 5MB each)": "Accepted: JPG, PNG, PDF, DOC, DOCX (max 5MB each)",
    "Account Deactivated": "Account Deactivated",
    "Account Status": "Account Status",
    "Account deactivated.": "Account deactivated.",
    "Account reactivated.": "Account reactivated.",
    "Ad Reports Against This User's Ads": "Ad Reports Against This User's Ads",
    "Ad Reports Filed By This User": "Ad Reports Filed By This User",
    "Add a note for this approval...": "Add a note for this approval...",
    "Add a note for this rejection...": "Add a note for this rejection...",
    "Add an internal note about this decision…": "Add an internal note about this decision…",
    "Additional details about this violation…": "Additional details about this violation…",
    "Affected Ad": "Affected Ad",
    "Appeal Awaiting Review": "Appeal Awaiting Review",
    "Appeal approved.": "Appeal approved.",
    "Appeal attachment": "Appeal attachment",
    "Appeal rejected.": "Appeal rejected.",
    "Approve Appeal": "Approve Appeal",
    "Approve Badge": "Approve Badge",
    "Attachments": "Attachments",
    "Badge Documents": "Badge Documents",
    "Badge Note": "Badge Note",
    "Classification": "Classification",
    "Contact Phone": "Contact Phone",
    "DATE": "DATE",
    "Deactivate Account": "Deactivate Account",
    "Deactivated By": "Deactivated By",
    "Deactivated On": "Deactivated On",
    "Deactivated for": "Deactivated for",
    "Deactivated on": "Deactivated on",
    "Deactivation Reason": "Deactivation Reason",
    "Deduct": "Deduct",
    "Deduct Balance": "Deduct Balance",
    "Deduct Wallet Balance": "Deduct Wallet Balance",
    "Documents": "Documents",
    "Explain why this appeal is being rejected…": "Explain why this appeal is being rejected…",
    "Explanation": "Explanation",
    "Failed to issue violation.": "Failed to issue violation.",
    "Failed to review appeal.": "Failed to review appeal.",
    "Failed to update account status.": "Failed to update account status.",
    "Failed to update verification status.": "Failed to update verification status.",
    "Failed to update wallet.": "Failed to update wallet.",
    "Give Violation": "Give Violation",
    "Joined Date": "Joined Date",
    "No ads found for this user.": "No ads found for this user.",
    "No ads found. Switch to the Ads tab to load them first.": "No ads found. Switch to the Ads tab to load them first.",
    "No reports have been filed against this user's ads.": "No reports have been filed against this user's ads.",
    "No reports have been filed against this user.": "No reports have been filed against this user.",
    "No violations found for this user.": "No violations found for this user.",
    "Owner": "Owner",
    "Please enter a reason for rejecting this appeal.": "Please enter a reason for rejecting this appeal.",
    "Please select an ad.": "Please select an ad.",
    "Policy Non-Compliance": "Policy Non-Compliance",
    "Profile Details": "Profile Details",
    "Reactivate": "Reactivate",
    "Reactivate Account": "Reactivate Account",
    "Reason": "Reason",
    "Reason for rejection": "Reason for rejection",
    "Reject Appeal": "Reject Appeal",
    "Reject Badge": "Reject Badge",
    "Report image": "Report image",
    "Reports Against This User": "Reports Against This User",
    "Restricted": "Restricted",
    "Review Note": "Review Note",
    "Reviewed By": "Reviewed By",
    "Select an ad…": "Select an ad…",
    "Signin Method": "Signin Method",
    "Submitted On": "Submitted On",
    "Submitted on": "Submitted on",
    "Submitting…": "Submitting…",
    "TYPE OF VIOLATION": "TYPE OF VIOLATION",
    "The account stays deactivated. The user will be notified with the reason you enter below.": "The account stays deactivated. The user will be notified with the reason you enter below.",
    "The account will be reactivated immediately and the user will be notified that they can sign in again.": "The account will be reactivated immediately and the user will be notified that they can sign in again.",
    "The user will be signed out of the platform and blocked from signing in again. They will be notified with the reason you enter below.": "The user will be signed out of the platform and blocked from signing in again. They will be notified with the reason you enter below.",
    "The user will regain access to the platform and be notified that their account is active again.": "The user will regain access to the platform and be notified that their account is active again.",
    "This user cannot use the platform.": "This user cannot use the platform.",
    "This user has appealed their deactivation. Review the details below and approve or reject the appeal.": "This user has appealed their deactivation. Review the details below and approve or reject the appeal.",
    "This user has not reported any ads.": "This user has not reported any ads.",
    "Type of Violation": "Type of Violation",
    "Under Review": "Under Review",
    "Unknown": "Unknown",
    "Upload Documents": "Upload Documents",
    "User Ads": "User Ads",
    "User Appeal": "User Appeal",
    "User Details": "User Details",
    "User Info": "User Info",
    "User not found": "User not found",
    "User verification approved successfully!": "User verification approved successfully!",
    "User verification rejected successfully!": "User verification rejected successfully!",
    "User's explanation": "User's explanation",
    "Violation issued successfully!": "Violation issued successfully!",
    "Violations": "Violations",
    "Wallet Balance": "Wallet Balance",
    "by": "by",
    "e.g. Policy Non-Compliance": "e.g. Policy Non-Compliance",
    "e.g. Refund, penalty, bonus…": "e.g. Refund, penalty, bonus…",
    "on": "on",
    "report": "report",
    "reports": "reports",
    "Toggle Status": "Toggle Status",
    "All": "All",
    "Are you sure you want to delete? It may affect your products information": "Are you sure you want to delete? It may affect your products information",
    "Category - Properties": "Category - Properties",
    "Enter Main Title": "Enter Main Title",
    "Failed to delete property. Please try again.": "Failed to delete property. Please try again.",
    "Failed to update properties. Please try again.": "Failed to update properties. Please try again.",
    "Is Locked": "Is Locked",
    "Parent Title": "Parent Title",
    "Parent Title Ar": "Parent Title Ar",
    "Properties updated successfully!": "Properties updated successfully!",
    "Property Name": "Property Name",
    "Property Name Ar": "Property Name Ar",
    "Property deleted successfully!": "Property deleted successfully!",
    "optional": "optional",
    "Enter Title Arabic": "Enter Title Arabic",
    "Failed to delete subcategory. Please try again.": "Failed to delete subcategory. Please try again.",
    "Failed to update subcategories. Please try again.": "Failed to update subcategories. Please try again.",
    "SubCategories updated successfully!": "SubCategories updated successfully!",
    "SubCategory deleted successfully!": "SubCategory deleted successfully!",
    "You want to logout": "You want to logout",
    "Yes, logout!": "Yes, logout!",
    "Yes, delete it!": "Yes, delete it!",
  },

  ar:{
      "Dashboard": "لوحة التحكم",
      "Navigation Links": "روابط التنقل",
      "Customers Management": "إدارة العملاء",
      "Doctors Management": "إدارة الأطباء",
      "Plants Management": "إدارة النباتات",
      "Articles Management": "إدارة المقالات",
      "Exhibitions Management": "إدارة المعارض",
      "Activities Management": "إدارة الأنشطة",
      "Ads Management": "إدارة الإعلانات",
      "Advertiser Management": "إدارة المعلنين",
      "Fesilah Cards": "بطاقات فسيلة",
      "Fesilah Vouchers": "قسائم فسيلة",
      "Reviews Management": "إدارة التقييمات",
      "Promo Codes": "الرموز الترويجية",
      "Send Notifications": "إرسال الإشعارات",
      "Subscription Management": "إدارة الاشتراكات",
      "Subscription Plans": "خطط الاشتراك",
      "Subscription History": "سجل الاشتراكات",
      "AutoRenewal Logs": "سجلات التجديد التلقائي",
      "Platform Management": "إدارة المنصة",
      "Categories": "الفئات",
      "Topic": "المواضيع",
      "Countries": "الدول",
      "Interests": "الاهتمامات",
      "Pages Management": "إدارة الصفحات",
      "Ad Category": "فئة الإعلان",
      "Ad Type": "نوع الإعلان",
      "Ad Packages": "باقات الإعلانات",
      "Agricultural Influencers": "المؤثرون الزراعيون",
      "Banned Keywords": "الكلمات المحظورة",
      "Account Types": "أنواع الحسابات",
      "App Settings": "إعدادات التطبيق",
      "Settings": "الإعدادات",
      "App Banners": "لافتات التطبيق",
      "Contacts": "جهات الاتصال",
      "Access Control": "التحكم في الوصول",
      "System Users": "مستخدمو النظام",
      "Roles": "الأدوار",
      "Finance & Payments": "المالية والمدفوعات",
      "Reports & Stats": "التقارير والإحصائيات",
      "Users Report": "تقرير المستخدمين",
      "Supply & Demand": "العرض والطلب",
      "Ad Categories": "فئات الإعلانات",
      "Advertising Revenue": "إيرادات الإعلانات",
      "Financial Reports": "التقارير المالية",
      "Activity Logs": "سجلات النشاط",
      "Account": "الحساب",
      "Logout": "تسجيل الخروج",
      "Search users, ads, reports…": "ابحث عن المستخدمين والإعلانات والتقارير…",
      "Searching…": "جارٍ البحث…",
      "No results for": "لا توجد نتائج لـ",
      "Users": "المستخدمون",
      "Ads": "الإعلانات",
      "Reports": "التقارير",
      "Switch to Light Mode": "التبديل إلى الوضع الفاتح",
      "Switch to Dark Mode": "التبديل إلى الوضع الداكن",
      "Notifications": "الإشعارات",
      "Mark all read": "تحديد الكل كمقروء",
      "No notifications yet": "لا توجد إشعارات بعد",
      "View all notifications": "عرض كل الإشعارات",
      "Account Settings": "إعدادات الحساب",
      "Fesilah Education": "فسيلة التعليمية",
      "Fesilah Trade": "فسيلة التجارية",
      "ago": "مضت",
      "About": "حول",
      "Support": "الدعم",
      "Home": "الرئيسية",
      "Dashboards": "لوحات التحكم",
      "Error loading dashboard": "خطأ في تحميل لوحة التحكم",
      "Total Products": "إجمالي المنتجات",
      "Total Customers": "إجمالي العملاء",
      "Total Articles": "إجمالي المقالات",
      "Total Activities": "إجمالي الأنشطة",
      "Total Exhibitions": "إجمالي المعارض",
      "Total Tickets": "إجمالي التذاكر",
      "Unresponded Tickets": "التذاكر غير المجاب عنها",
      "Opened Tickets": "التذاكر المفتوحة",
      "Closed Tickets": "التذاكر المغلقة",
      "Total Subscriptions": "إجمالي الاشتراكات",
      "Active Subscriptions": "الاشتراكات النشطة",
      "Expired Subscriptions": "الاشتراكات المنتهية",
      "Customers Status": "حالة العملاء",
      "Subscribed vs Unsubscribed": "المشتركون مقابل غير المشتركين",
      "Subscribed Customers": "العملاء المشتركون",
      "UnSubscribed Customers": "العملاء غير المشتركين",
      "No data available": "لا توجد بيانات متاحة",
      "Subscription Purchased Stats": "إحصائيات شراء الاشتراكات",
      "Customers purchase subscription per month": "اشتراكات العملاء المشتراة شهريًا",
      "Subscription Purchased": "الاشتراكات المشتراة",
      "Customers Stats": "إحصائيات العملاء",
      "Customers registered per month": "العملاء المسجلون شهريًا",
      "Customers Registered": "العملاء المسجلون",
      "Customers": "العملاء",
      "Doctors": "الأطباء",
      "Items": "العناصر",
      "Name": "الاسم",
      "Email": "البريد الإلكتروني",
      "Phone": "الهاتف",
      "Status": "الحالة",
      "Actions": "الإجراءات",
      "Image": "الصورة",
      "Username": "اسم المستخدم",
      "Address": "العنوان",
      "Account Type": "نوع الحساب",
      "Verification": "التحقق",
      "Wallet": "المحفظة",
      "Created Date": "تاريخ الإنشاء",
      "Category": "الفئة",
      "Description": "الوصف",
      "Name Ar": "الاسم بالعربية",
      "Is Premium": "مميّز",
      "Export CSV": "تصدير CSV",
      "Export": "تصدير",
      "Exporting...": "جارٍ التصدير...",
      "Search Name, Email Or Phone..": "ابحث بالاسم أو البريد أو الهاتف..",
      "Search Package Name..": "ابحث باسم الباقة..",
      "Date Range": "النطاق الزمني",
      "All Statuses": "كل الحالات",
      "All Verifications": "كل عمليات التحقق",
      "Green": "أخضر",
      "Gold": "ذهبي",
      "All Countries": "كل الدول",
      "All Cities": "كل المدن",
      "Clear": "مسح",
      "Filter": "تصفية",
      "Add User": "إضافة مستخدم",
      "Add Doctor": "إضافة طبيب",
      "Add New Item": "إضافة عنصر جديد",
      "Action": "إجراء",
      "Delete": "حذف",
      "Confirm": "تأكيد",
      "All Users": "كل المستخدمين",
      "Email Login": "تسجيل بالبريد",
      "Google": "جوجل",
      "Apple": "آبل",
      "Guests": "الضيوف",
      "Active": "نشط",
      "Suspended": "موقوف",
      "Inactive": "غير نشط",
      "Unverified": "غير موثّق",
      "N/A": "غير متاح",
      "No users found": "لا يوجد مستخدمون",
      "Error loading users": "خطأ في تحميل المستخدمين",
      "Error loading doctors": "خطأ في تحميل الأطباء",
      "Error loading items": "خطأ في تحميل العناصر",
      "Click to toggle status": "انقر لتبديل الحالة",
      "Suspend User?": "إيقاف المستخدم؟",
      "Deactivate User?": "إلغاء تنشيط المستخدم؟",
      "Deactivated": "معطّل",
      "Are you sure you want to deactivate": "هل أنت متأكد أنك تريد إلغاء تنشيط",
      "Yes, Deactivate": "نعم، ألغِ التنشيط",
      "Reason for deactivation": "سبب إلغاء التنشيط",
      "Describe why this account is being deactivated…": "اذكر سبب إلغاء تنشيط هذا الحساب…",
      "The user will be notified with this reason.": "سيتم إشعار المستخدم بهذا السبب.",
      "Please enter a reason for deactivation.": "يرجى إدخال سبب إلغاء التنشيط.",
      "Activate User?": "تفعيل المستخدم؟",
      "Are you sure you want to suspend": "هل أنت متأكد أنك تريد إيقاف",
      "They won't be able to access the platform.": "لن يتمكن من الوصول إلى المنصة.",
      "Are you sure you want to activate": "هل أنت متأكد أنك تريد تفعيل",
      "They will regain access to the platform.": "سيستعيد الوصول إلى المنصة.",
      "Cancel": "إلغاء",
      "Yes, Suspend": "نعم، أوقف",
      "Yes, Activate": "نعم، فعّل",
      "Updating…": "جارٍ التحديث…",
      "Add Wallet Balance": "إضافة رصيد للمحفظة",
      "Current Balance": "الرصيد الحالي",
      "Amount to Add": "المبلغ المراد إضافته",
      "Enter amount": "أدخل المبلغ",
      "Note (optional)": "ملاحظة (اختياري)",
      "e.g. Refund, bonus credit…": "مثال: استرداد، رصيد مكافأة…",
      "Adding…": "جارٍ الإضافة…",
      "Add Balance": "إضافة رصيد",
      "Failed to export users. Please try again.": "فشل تصدير المستخدمين. حاول مرة أخرى.",
      "User deleted successfully!": "تم حذف المستخدم بنجاح!",
      "Failed to delete user. Please try again.": "فشل حذف المستخدم. حاول مرة أخرى.",
      "User status updated successfully!": "تم تحديث حالة المستخدم بنجاح!",
      "Failed to update user status. Please try again.": "فشل تحديث حالة المستخدم. حاول مرة أخرى.",
      "Please enter a valid amount.": "يرجى إدخال مبلغ صحيح.",
      "Wallet balance updated!": "تم تحديث رصيد المحفظة!",
      "Failed to update wallet. Please try again.": "فشل تحديث المحفظة. حاول مرة أخرى.",
      "Doctor deleted successfully!": "تم حذف الطبيب بنجاح!",
      "Failed to delete doctor. Please try again.": "فشل حذف الطبيب. حاول مرة أخرى.",
      "Doctor status updated successfully!": "تم تحديث حالة الطبيب بنجاح!",
      "Failed to update doctor status. Please try again.": "فشل تحديث حالة الطبيب. حاول مرة أخرى.",
      "Item deleted successfully!": "تم حذف العنصر بنجاح!",
      "Failed to delete item. Please try again.": "فشل حذف العنصر. حاول مرة أخرى.",
      "Item status updated successfully!": "تم تحديث حالة العنصر بنجاح!",
      "Failed to update item status. Please try again.": "فشل تحديث حالة العنصر. حاول مرة أخرى.",
      "Premium status updated successfully!": "تم تحديث حالة التميّز بنجاح!",
      "Failed to update premium status. Please try again.": "فشل تحديث حالة التميّز. حاول مرة أخرى.",
      "Please select an action and at least one item": "يرجى اختيار إجراء وعنصر واحد على الأقل",
      "Are you sure?": "هل أنت متأكد؟",
      "You won't be able to revert this!": "لن تتمكن من التراجع عن هذا!",
      "Bulk action completed successfully!": "تم تنفيذ الإجراء الجماعي بنجاح!",
      "Failed to perform bulk action. Please try again.": "فشل تنفيذ الإجراء الجماعي. حاول مرة أخرى.",
      "Title": "العنوان",
      "Tags": "الوسوم",
      "Country": "الدولة",
      "Is Featured": "بارز",
      "Main Articles": "المقالات الرئيسية",
      "Tags List": "قائمة الوسوم",
      "Add New Article": "إضافة مقال جديد",
      "Search Article Title..": "ابحث بعنوان المقال..",
      "Article deleted successfully!": "تم حذف المقال بنجاح!",
      "Failed to delete article. Please try again.": "فشل حذف المقال. حاول مرة أخرى.",
      "Article status updated successfully!": "تم تحديث حالة المقال بنجاح!",
      "Failed to update article status. Please try again.": "فشل تحديث حالة المقال. حاول مرة أخرى.",
      "Featured status updated successfully!": "تم تحديث حالة الإبراز بنجاح!",
      "Failed to update featured status. Please try again.": "فشل تحديث حالة الإبراز. حاول مرة أخرى.",
      "Please select an action and at least one article": "يرجى اختيار إجراء ومقال واحد على الأقل",
      "Error loading articles": "خطأ في تحميل المقالات",
      "Exhibitions": "المعارض",
      "Add New Exhibition": "إضافة معرض جديد",
      "Search Exhibition Title..": "ابحث بعنوان المعرض..",
      "Exhibition DateTime": "تاريخ ووقت المعرض",
      "Exhibition deleted successfully!": "تم حذف المعرض بنجاح!",
      "Failed to delete exhibition. Please try again.": "فشل حذف المعرض. حاول مرة أخرى.",
      "Please select an action and at least one exhibition": "يرجى اختيار إجراء ومعرض واحد على الأقل",
      "Error loading exhibitions": "خطأ في تحميل المعارض",
      "Activities": "الأنشطة",
      "Add New Activity": "إضافة نشاط جديد",
      "Search Activity Title..": "ابحث بعنوان النشاط..",
      "Activity DateTime": "تاريخ ووقت النشاط",
      "Activity deleted successfully!": "تم حذف النشاط بنجاح!",
      "Failed to delete activity. Please try again.": "فشل حذف النشاط. حاول مرة أخرى.",
      "Please select an action and at least one activity": "يرجى اختيار إجراء ونشاط واحد على الأقل",
      "Error loading activities": "خطأ في تحميل الأنشطة",
      "Sent Notifications": "الإشعارات المرسلة",
      "Send New Notification": "إرسال إشعار جديد",
      "Body": "المحتوى",
      "Target": "الفئة المستهدفة",
      "Method": "الطريقة",
      "Sent At": "تاريخ الإرسال",
      "Pending": "قيد الانتظار",
      "No notifications found": "لا توجد إشعارات",
      "Error loading notifications": "خطأ في تحميل الإشعارات",
      "Website Contacts": "تواصل الموقع",
      "Search by Name, email...": "ابحث بالاسم أو البريد...",
      "Full Name": "الاسم الكامل",
      "Email address": "البريد الإلكتروني",
      "Message": "الرسالة",
      "No contacts found": "لا توجد رسائل",
      "Error loading contacts": "خطأ في تحميل جهات الاتصال",
      "Main Categories": "الفئات الرئيسية",
      "Search Category Title..": "ابحث بعنوان الفئة..",
      "Add New Category": "إضافة فئة جديدة",
      "Title Arabic": "العنوان بالعربية",
      "Name Arabic": "الاسم بالعربية",
      "Properties": "الخصائص",
      "SubCategories": "الفئات الفرعية",
      "Category deleted successfully!": "تم حذف الفئة بنجاح!",
      "Failed to delete category. Please try again.": "فشل حذف الفئة. حاول مرة أخرى.",
      "Category status updated successfully!": "تم تحديث حالة الفئة بنجاح!",
      "Failed to update category status. Please try again.": "فشل تحديث حالة الفئة. حاول مرة أخرى.",
      "Error loading categories": "خطأ في تحميل الفئات",
      "Add New Country": "إضافة دولة جديدة",
      "Search Country Name..": "ابحث باسم الدولة..",
      "Currency": "العملة",
      "Cities": "المدن",
      "Country deleted successfully!": "تم حذف الدولة بنجاح!",
      "Failed to delete country. Please try again.": "فشل حذف الدولة. حاول مرة أخرى.",
      "Country status updated successfully!": "تم تحديث حالة الدولة بنجاح!",
      "Failed to update country status. Please try again.": "فشل تحديث حالة الدولة. حاول مرة أخرى.",
      "Activate": "تفعيل",
      "Deactivate": "إلغاء التفعيل",
      "Error loading countries": "خطأ في تحميل الدول",
      "Cities in": "المدن في",
      "Add New City": "إضافة مدينة جديدة",
      "Search City Name..": "ابحث باسم المدينة..",
      "City deleted successfully!": "تم حذف المدينة بنجاح!",
      "Failed to delete city. Please try again.": "فشل حذف المدينة. حاول مرة أخرى.",
      "Error loading cities": "خطأ في تحميل المدن",
      "Add New Banner": "إضافة لافتة جديدة",
      "Search Banner Title..": "ابحث بعنوان اللافتة..",
      "Banner deleted successfully!": "تم حذف اللافتة بنجاح!",
      "Failed to delete banner. Please try again.": "فشل حذف اللافتة. حاول مرة أخرى.",
      "Error loading banners": "خطأ في تحميل اللافتات",
      "Add New Topic": "إضافة موضوع جديد",
      "Search Topic Title..": "ابحث بعنوان الموضوع..",
      "Topic deleted successfully!": "تم حذف الموضوع بنجاح!",
      "Failed to delete topic. Please try again.": "فشل حذف الموضوع. حاول مرة أخرى.",
      "Topic status updated successfully!": "تم تحديث حالة الموضوع بنجاح!",
      "Failed to update topic status. Please try again.": "فشل تحديث حالة الموضوع. حاول مرة أخرى.",
      "Topic premium status updated successfully!": "تم تحديث حالة تميّز الموضوع بنجاح!",
      "Failed to update topic premium status. Please try again.": "فشل تحديث حالة تميّز الموضوع. حاول مرة أخرى.",
      "Error loading topics": "خطأ في تحميل المواضيع",
      "Discard": "تجاهل",
      "Submit": "إرسال",
      "Back": "رجوع",
      "Please wait...": "يرجى الانتظار...",
      "Content": "المحتوى",
      "Content Arabic": "المحتوى بالعربية",
      "Content (Arabic)": "المحتوى (بالعربية)",
      "Title (Arabic)": "العنوان (بالعربية)",
      "Description Arabic": "الوصف بالعربية",
      "Description (Arabic)": "الوصف (بالعربية)",
      "Tags Arabic": "الوسوم بالعربية",
      "Tags Ar": "الوسوم بالعربية",
      "Select Tags": "اختر الوسوم",
      "Select Tags Arabic": "اختر الوسوم بالعربية",
      "Note": "ملاحظة",
      "Note Arabic": "ملاحظة بالعربية",
      "Location": "الموقع",
      "Location Ar": "الموقع بالعربية",
      "Select Country": "اختر الدولة",
      "Upload Picture": "تحميل صورة",
      "Write tags and press enter": "اكتب الوسوم واضغط إدخال",
      "Write arabic tags and press enter": "اكتب الوسوم بالعربية واضغط إدخال",
      "Doctor": "الطبيب",
      "Topics": "المواضيع",
      "Start Date": "تاريخ البدء",
      "End Date": "تاريخ الانتهاء",
      "Edit Article": "تعديل المقال",
      "Articles": "المقالات",
      "Article Details": "تفاصيل المقال",
      "Article not found": "المقال غير موجود",
      "Enter Article Title": "أدخل عنوان المقال",
      "Enter Article Title in Arabic": "أدخل عنوان المقال بالعربية",
      "Upload Article Image": "تحميل صورة المقال",
      "Article updated successfully!": "تم تحديث المقال بنجاح!",
      "Article created successfully!": "تم إنشاء المقال بنجاح!",
      "Failed to update article. Please try again.": "فشل تحديث المقال. حاول مرة أخرى.",
      "Failed to create article. Please try again.": "فشل إنشاء المقال. حاول مرة أخرى.",
      "Edit Exhibition": "تعديل المعرض",
      "Exhibition Details": "تفاصيل المعرض",
      "Exhibition not found": "المعرض غير موجود",
      "Enter Exhibition Title": "أدخل عنوان المعرض",
      "Enter Exhibition Title in Arabic": "أدخل عنوان المعرض بالعربية",
      "Enter Exhibition Note": "أدخل ملاحظة المعرض",
      "Enter Exhibition Note in Arabic": "أدخل ملاحظة المعرض بالعربية",
      "Entrance Fee": "رسوم الدخول",
      "Enter Exhibition Entrance Fee": "أدخل رسوم دخول المعرض",
      "Booking Link (optional)": "رابط الحجز (اختياري)",
      "Enter Exhibition Booking link if its paid entrance": "أدخل رابط حجز المعرض إذا كان الدخول مدفوعًا",
      "Exhibition Link": "رابط المعرض",
      "Enter Exhibition link": "أدخل رابط المعرض",
      "Enter Exhibition Location": "أدخل موقع المعرض",
      "Enter Exhibition Location Arabic": "أدخل موقع المعرض بالعربية",
      "Exhibition At": "تاريخ المعرض",
      "Exhibition updated successfully!": "تم تحديث المعرض بنجاح!",
      "Exhibition created successfully!": "تم إنشاء المعرض بنجاح!",
      "Failed to update exhibition. Please try again.": "فشل تحديث المعرض. حاول مرة أخرى.",
      "Failed to create exhibition. Please try again.": "فشل إنشاء المعرض. حاول مرة أخرى.",
      "Edit Activity": "تعديل النشاط",
      "Enter Activity Title": "أدخل عنوان النشاط",
      "Enter Activity Title in Arabic": "أدخل عنوان النشاط بالعربية",
      "Enter Activity Note": "أدخل ملاحظة النشاط",
      "Enter Activity Note in Arabic": "أدخل ملاحظة النشاط بالعربية",
      "Activity Link": "رابط النشاط",
      "Enter Activity Link": "أدخل رابط النشاط",
      "Enter Entrance Fee": "أدخل رسوم الدخول",
      "Enter Activity Booking link if its paid entrance": "أدخل رابط حجز النشاط إذا كان الدخول مدفوعًا",
      "Enter Activity Location": "أدخل موقع النشاط",
      "Enter Activity Location Arabic": "أدخل موقع النشاط بالعربية",
      "Activity At": "تاريخ النشاط",
      "Enter Activity Doctor/Professor": "أدخل طبيب/أستاذ النشاط",
      "Activity updated successfully!": "تم تحديث النشاط بنجاح!",
      "Activity created successfully!": "تم إنشاء النشاط بنجاح!",
      "Failed to update activity. Please try again.": "فشل تحديث النشاط. حاول مرة أخرى.",
      "Failed to create activity. Please try again.": "فشل إنشاء النشاط. حاول مرة أخرى.",
      "Send Notification": "إرسال إشعار",
      "Notification Title": "عنوان الإشعار",
      "Enter notification title": "أدخل عنوان الإشعار",
      "Notification Body": "محتوى الإشعار",
      "Enter notification content": "أدخل محتوى الإشعار",
      "Image (Optional)": "صورة (اختياري)",
      "Remove Image": "إزالة الصورة",
      "Click to upload image": "انقر لتحميل صورة",
      "Recommended: JPEG or PNG, max 5MB. Shown in push notifications and emails.": "موصى به: JPEG أو PNG، بحد أقصى 5 ميجابايت. تظهر في الإشعارات والبريد الإلكتروني.",
      "Target Users": "المستخدمون المستهدفون",
      "All Active Users": "كل المستخدمين النشطين",
      "New Users (Last 30 days)": "المستخدمون الجدد (آخر 30 يومًا)",
      "Old Users (Before 30 days)": "المستخدمون القدامى (قبل 30 يومًا)",
      "Specific Users": "مستخدمون محددون",
      "Search & Select Users": "ابحث واختر المستخدمين",
      "Search by name, email or phone...": "ابحث بالاسم أو البريد أو الهاتف...",
      "Add": "إضافة",
      "Send Method": "طريقة الإرسال",
      "Push & Email": "إشعار وبريد",
      "Push Notification Only": "إشعار فقط",
      "Email Only": "بريد إلكتروني فقط",
      "Target Country (Optional)": "الدولة المستهدفة (اختياري)",
      "Leave empty to send to users in all countries.": "اتركه فارغًا للإرسال إلى المستخدمين في كل الدول.",
      "Target City (Optional)": "المدينة المستهدفة (اختياري)",
      "Select a country first": "اختر دولة أولاً",
      "Leave empty to send to users in all cities of the selected country.": "اتركه فارغًا للإرسال إلى المستخدمين في كل مدن الدولة المختارة.",
      "Send Time": "وقت الإرسال",
      "Send Now": "إرسال الآن",
      "Schedule for Later": "جدولة لاحقًا",
      "Schedule Notification": "جدولة الإشعار",
      "Please select a valid image file": "يرجى اختيار ملف صورة صالح",
      "Please select at least one user": "يرجى اختيار مستخدم واحد على الأقل",
      "Please select a scheduled date and time": "يرجى اختيار تاريخ ووقت الجدولة",
      "Notification queued successfully": "تم وضع الإشعار في قائمة الانتظار بنجاح",
      "Failed to send notification": "فشل إرسال الإشعار",
      "Edit User": "تعديل المستخدم",
      "Enter Package Name": "أدخل الاسم",
      "Enter User Email": "أدخل بريد المستخدم",
      "Enter Phone No.": "أدخل رقم الهاتف",
      "City": "المدينة",
      "Select City": "اختر المدينة",
      "Select Account Type": "اختر نوع الحساب",
      "No Account Type": "بدون نوع حساب",
      "User updated successfully!": "تم تحديث المستخدم بنجاح!",
      "User created successfully!": "تم إنشاء المستخدم بنجاح!",
      "Failed to update user. Please try again.": "فشل تحديث المستخدم. حاول مرة أخرى.",
      "Failed to create user. Please try again.": "فشل إنشاء المستخدم. حاول مرة أخرى.",
      "Edit Doctor": "تعديل الطبيب",
      "Add New Doctor": "إضافة طبيب جديد",
      "Enter Doctor name": "أدخل اسم الطبيب",
      "Email Address": "البريد الإلكتروني",
      "Enter Doctor Email Address": "أدخل البريد الإلكتروني للطبيب",
      "Password": "كلمة المرور",
      "(Password can't be viewed but can update from here)": "(لا يمكن عرض كلمة المرور لكن يمكن تحديثها من هنا)",
      "Enter Password": "أدخل كلمة المرور",
      "Phone No": "رقم الهاتف",
      "Enter Phone Number": "أدخل رقم الهاتف",
      "Topic:": "الموضوع:",
      "Select Doctor Categories": "اختر فئات الطبيب",
      "Password is required for new doctors": "كلمة المرور مطلوبة للأطباء الجدد",
      "Doctor updated successfully!": "تم تحديث الطبيب بنجاح!",
      "Doctor created successfully!": "تم إنشاء الطبيب بنجاح!",
      "Failed to update doctor. Please try again.": "فشل تحديث الطبيب. حاول مرة أخرى.",
      "Failed to create doctor. Please try again.": "فشل إنشاء الطبيب. حاول مرة أخرى.",
      "Edit Item": "تعديل العنصر",
      "Enter Item Name": "أدخل اسم العنصر",
      "Enter Item Name in Arabic": "أدخل اسم العنصر بالعربية",
      "Category:": "الفئة:",
      "Select Category": "اختر الفئة",
      "SubCategory:": "الفئة الفرعية:",
      "Select SubCategories": "اختر الفئات الفرعية",
      "Write Description": "اكتب الوصف",
      "Write Description in Arabic": "اكتب الوصف بالعربية",
      "Upload Images": "تحميل الصور",
      "Item Properties": "خصائص العنصر",
      "Item created successfully!": "تم إنشاء العنصر بنجاح!",
      "Failed to update item. Please try again.": "فشل تحديث العنصر. حاول مرة أخرى.",
      "Failed to create item. Please try again.": "فشل إنشاء العنصر. حاول مرة أخرى.",
      "Packages": "الباقات",
      "Add New Package": "إضافة باقة جديدة",
      "Price": "السعر",
      "Duration": "المدة",
      "Package deleted successfully!": "تم حذف الباقة بنجاح!",
      "Failed to delete package. Please try again.": "فشل حذف الباقة. حاول مرة أخرى.",
      "Package status updated successfully!": "تم تحديث حالة الباقة بنجاح!",
      "Failed to update package status. Please try again.": "فشل تحديث حالة الباقة. حاول مرة أخرى.",
      "Error loading packages": "خطأ في تحميل الباقات",
      "Subscriptions": "الاشتراكات",
      "Select User": "اختر المستخدم",
      "Select Package": "اختر الباقة",
      "User": "المستخدم",
      "Package": "الباقة",
      "Purchase/Renew Date": "تاريخ الشراء/التجديد",
      "Expired Date": "تاريخ الانتهاء",
      "Is Auto Renewed": "تجديد تلقائي",
      "Yes": "نعم",
      "No": "لا",
      "Expired": "منتهي",
      "Error loading subscription history": "خطأ في تحميل سجل الاشتراكات",
      "Stripe AutoRenewal logs": "سجلات التجديد التلقائي عبر سترايب",
      "Error": "الخطأ",
      "Details": "التفاصيل",
      "Error At": "وقت الخطأ",
      "Error loading auto-renewal logs": "خطأ في تحميل سجلات التجديد التلقائي",
      "Edit Package": "تعديل الباقة",
      "Package Name": "اسم الباقة",
      "Package Name Arabic": "اسم الباقة بالعربية",
      "Enter Package Name in Arabic": "أدخل اسم الباقة بالعربية",
      "Time Period": "المدة الزمنية",
      "Enter Time Period": "أدخل المدة الزمنية",
      "months": "أشهر",
      "days": "أيام",
      "Enter Package Price": "أدخل سعر الباقة",
      "Add Features": "إضافة ميزات",
      "write feature here": "اكتب الميزة هنا",
      "write feature in arabic": "اكتب الميزة بالعربية",
      "- Remove": "- إزالة",
      "Package updated successfully!": "تم تحديث الباقة بنجاح!",
      "Package created successfully!": "تم إنشاء الباقة بنجاح!",
      "Failed to update package. Please try again.": "فشل تحديث الباقة. حاول مرة أخرى.",
      "Failed to create package. Please try again.": "فشل إنشاء الباقة. حاول مرة أخرى.",
      "Package Details": "تفاصيل الباقة",
      "Package not found": "الباقة غير موجودة",
      "Name (Arabic)": "الاسم (بالعربية)",
      "Features": "الميزات",
      "Features (Arabic)": "الميزات (بالعربية)",
      "Item Details": "تفاصيل العنصر",
      "Item not found": "العنصر غير موجود",
      "Images": "الصور",
      "Edit Category": "تعديل الفئة",
      "Enter Category Title": "أدخل عنوان الفئة",
      "Enter Category Title in Arabic": "أدخل عنوان الفئة بالعربية",
      "Upload Banner": "تحميل اللافتة",
      "Category created successfully!": "تم إنشاء الفئة بنجاح!",
      "Failed to update category. Please try again.": "فشل تحديث الفئة. حاول مرة أخرى.",
      "Failed to create category. Please try again.": "فشل إنشاء الفئة. حاول مرة أخرى.",
      "Category Details": "تفاصيل الفئة",
      "Category not found": "الفئة غير موجودة",
      "Edit Country": "تعديل الدولة",
      "Enter Country Name": "أدخل اسم الدولة",
      "Enter Country Name in Arabic": "أدخل اسم الدولة بالعربية",
      "Currency Code": "رمز العملة",
      "ISO 4217 currency code (3 letters)": "رمز العملة وفق ISO 4217 (3 أحرف)",
      "Currency Code Arabic": "رمز العملة بالعربية",
      "Arabic currency symbol or code": "رمز أو اختصار العملة بالعربية",
      "e.g. USD, AED, SAR": "مثال: USD، AED، SAR",
      "e.g. د.إ, ر.س, د.ك": "مثال: د.إ، ر.س، د.ك",
      "Name is required and must be at least 3 characters long.": "الاسم مطلوب ويجب ألا يقل عن 3 أحرف.",
      "Name Arabic is required and must be at least 3 characters long.": "الاسم بالعربية مطلوب ويجب ألا يقل عن 3 أحرف.",
      "Validation failed": "فشل التحقق",
      "Country updated successfully!": "تم تحديث الدولة بنجاح!",
      "Country created successfully!": "تم إنشاء الدولة بنجاح!",
      "Failed to update country. Please try again.": "فشل تحديث الدولة. حاول مرة أخرى.",
      "Failed to create country. Please try again.": "فشل إنشاء الدولة. حاول مرة أخرى.",
      "Edit City": "تعديل المدينة",
      "Enter City Name": "أدخل اسم المدينة",
      "Enter City Name in Arabic": "أدخل اسم المدينة بالعربية",
      "City updated successfully!": "تم تحديث المدينة بنجاح!",
      "City created successfully!": "تم إنشاء المدينة بنجاح!",
      "Failed to update city. Please try again.": "فشل تحديث المدينة. حاول مرة أخرى.",
      "Failed to create city. Please try again.": "فشل إنشاء المدينة. حاول مرة أخرى.",
      "Edit Topic": "تعديل الموضوع",
      "Enter Topic Name": "أدخل اسم الموضوع",
      "Enter Topic Name in Arabic": "أدخل اسم الموضوع بالعربية",
      "Mark as Premium": "وضع كمميّز",
      "Topic created successfully!": "تم إنشاء الموضوع بنجاح!",
      "Failed to update topic. Please try again.": "فشل تحديث الموضوع. حاول مرة أخرى.",
      "Failed to create topic. Please try again.": "فشل إنشاء الموضوع. حاول مرة أخرى.",
      "Topic Details": "تفاصيل الموضوع",
      "Topic not found": "الموضوع غير موجود",
      "Language": "اللغة",
      "Sort Order": "ترتيب الفرز",
      "Edit Banner": "تعديل اللافتة",
      "Enter Banner Title": "أدخل عنوان اللافتة",
      "Enter Banner Title in Arabic": "أدخل عنوان اللافتة بالعربية",
      "Link To": "الربط إلى",
      "Exhibition": "معرض",
      "Activity": "نشاط",
      "Article": "مقال",
      "External URL": "رابط خارجي",
      "No Link": "بدون رابط",
      "Select Exhibition": "اختر المعرض",
      "Select Activity": "اختر النشاط",
      "Select Article": "اختر المقال",
      "Search and select...": "ابحث واختر...",
      "Enter External URL": "أدخل الرابط الخارجي",
      "Enter Sort Order (0, 1, 2...)": "أدخل ترتيب الفرز (0، 1، 2...)",
      "Lower numbers appear first. Default: 0": "الأرقام الأقل تظهر أولاً. الافتراضي: 0",
      "Banner Image": "صورة اللافتة",
      "Upload Banner Image": "تحميل صورة اللافتة",
      "Please select a link type.": "يرجى اختيار نوع الرابط.",
      "Please select a link option.": "يرجى اختيار خيار الرابط.",
      "Please enter an external URL.": "يرجى إدخال رابط خارجي.",
      "Please upload a banner image.": "يرجى تحميل صورة اللافتة.",
      "Banner updated successfully!": "تم تحديث اللافتة بنجاح!",
      "Banner created successfully!": "تم إنشاء اللافتة بنجاح!",
      "Failed to update banner. Please try again.": "فشل تحديث اللافتة. حاول مرة أخرى.",
      "Failed to create banner. Please try again.": "فشل إنشاء اللافتة. حاول مرة أخرى.",
      "Interest deleted successfully": "تم حذف الاهتمام بنجاح",
      "Failed to delete interest": "فشل حذف الاهتمام",
      "Interest activated successfully": "تم تفعيل الاهتمام بنجاح",
      "Interest deactivated successfully": "تم إلغاء تفعيل الاهتمام بنجاح",
      "Failed to update status": "فشل تحديث الحالة",
      "Error loading interests": "خطأ في تحميل الاهتمامات",
      "Add Interest": "إضافة اهتمام",
      "ID": "المعرّف",
      "Name (AR)": "الاسم (بالعربية)",
      "No interests found": "لا توجد اهتمامات",
      "Edit Interest": "تعديل الاهتمام",
      "Add New Interest": "إضافة اهتمام جديد",
      "Enter Interest Name": "أدخل اسم الاهتمام",
      "Enter Interest Name in Arabic": "أدخل اسم الاهتمام بالعربية",
      "Name is required and must be at least 2 characters long.": "الاسم مطلوب ويجب ألا يقل عن حرفين.",
      "Arabic Name is required and must be at least 2 characters long.": "الاسم بالعربية مطلوب ويجب ألا يقل عن حرفين.",
      "Interest updated successfully!": "تم تحديث الاهتمام بنجاح!",
      "Interest created successfully!": "تم إنشاء الاهتمام بنجاح!",
      "Failed to update interest. Please try again.": "فشل تحديث الاهتمام. حاول مرة أخرى.",
      "Failed to create interest. Please try again.": "فشل إنشاء الاهتمام. حاول مرة أخرى.",
      "Pages": "الصفحات",
      "Search Page Title..": "ابحث بعنوان الصفحة..",
      "Add New Page": "إضافة صفحة جديدة",
      "Page deleted successfully!": "تم حذف الصفحة بنجاح!",
      "Failed to delete page. Please try again.": "فشل حذف الصفحة. حاول مرة أخرى.",
      "Error loading pages": "خطأ في تحميل الصفحات",
      "Edit Page": "تعديل الصفحة",
      "Enter Page Title": "أدخل عنوان الصفحة",
      "Enter Page Title in Arabic": "أدخل عنوان الصفحة بالعربية",
      "Page updated successfully!": "تم تحديث الصفحة بنجاح!",
      "Page created successfully!": "تم إنشاء الصفحة بنجاح!",
      "Failed to update page. Please try again.": "فشل تحديث الصفحة. حاول مرة أخرى.",
      "Failed to create page. Please try again.": "فشل إنشاء الصفحة. حاول مرة أخرى.",
      "Page Details": "تفاصيل الصفحة",
      "Page not found": "الصفحة غير موجودة",
      "Slug": "الرابط المختصر",
      "Status updated!": "تم تحديث الحالة!",
      "Failed to update status.": "فشل تحديث الحالة.",
      "Account type deleted!": "تم حذف نوع الحساب!",
      "Failed to delete account type.": "فشل حذف نوع الحساب.",
      "Error loading account types": "خطأ في تحميل أنواع الحسابات",
      "Search account type...": "ابحث عن نوع الحساب...",
      "Add Account Type": "إضافة نوع حساب",
      "Created": "أُنشئ",
      "No account types found": "لا توجد أنواع حسابات",
      "Edit Account Type": "تعديل نوع الحساب",
      "New Account Type": "نوع حساب جديد",
      "Edit": "تعديل",
      "Title (English)": "العنوان (بالإنجليزية)",
      "e.g. Individual": "مثال: فردي",
      "e.g. فردي": "مثال: فردي",
      "Saving...": "جارٍ الحفظ...",
      "Update": "تحديث",
      "Create": "إنشاء",
      "Title is required (min 2 characters).": "العنوان مطلوب (حرفان على الأقل).",
      "Arabic title is required (min 2 characters).": "العنوان بالعربية مطلوب (حرفان على الأقل).",
      "Account type updated!": "تم تحديث نوع الحساب!",
      "Account type created!": "تم إنشاء نوع الحساب!",
      "Something went wrong.": "حدث خطأ ما.",
      "Ad Type status updated successfully!": "تم تحديث حالة نوع الإعلان بنجاح!",
      "Failed to update ad type status. Please try again.": "فشل تحديث حالة نوع الإعلان. حاول مرة أخرى.",
      "Ad Type deleted successfully!": "تم حذف نوع الإعلان بنجاح!",
      "Failed to delete ad type. Please try again.": "فشل حذف نوع الإعلان. حاول مرة أخرى.",
      "Error loading ad types": "خطأ في تحميل أنواع الإعلانات",
      "Ad Types": "أنواع الإعلانات",
      "Search Ad Type Title..": "ابحث بعنوان نوع الإعلان..",
      "Add New Ad Type": "إضافة نوع إعلان جديد",
      "Features Count": "عدد الميزات",
      "No ad types found": "لا توجد أنواع إعلانات",
      "Strategic Ad Types": "أنواع الإعلانات الاستراتيجية",
      "Edit Ad Type": "تعديل نوع الإعلان",
      "Enter Ad Type Title": "أدخل عنوان نوع الإعلان",
      "Enter Ad Type Title in Arabic": "أدخل عنوان نوع الإعلان بالعربية",
      "Mark as Free": "وضع كمجاني",
      "Free": "مجاني",
      "Images Limit": "حد الصور",
      "Enter Images Limit": "أدخل حد الصور",
      "Analytics Available": "التحليلات متاحة",
      "Targeting Available": "الاستهداف متاح",
      "Notification Sent": "تم إرسال الإشعار",
      "External Links Allowed": "السماح بالروابط الخارجية",
      "Duration Days": "أيام المدة",
      "e.g. 15 to 30 days": "مثال: من 15 إلى 30 يومًا",
      "Placement": "الموضع",
      "Select Placement": "اختر الموضع",
      "Relevant Section": "القسم ذو الصلة",
      "Premium": "مميّز",
      "Strategic": "استراتيجي",
      "Ordering": "الترتيب",
      "Select Ordering": "اختر الترتيب",
      "Chronological": "زمني",
      "Priority": "أولوية",
      "Prominent": "بارز",
      "Editable": "قابل للتعديل",
      "Select Editable Option": "اختر خيار التعديل",
      "Once Only": "مرة واحدة فقط",
      "Flexible": "مرن",
      "Ad Type updated successfully!": "تم تحديث نوع الإعلان بنجاح!",
      "Ad Type created successfully!": "تم إنشاء نوع الإعلان بنجاح!",
      "Failed to update ad type. Please try again.": "فشل تحديث نوع الإعلان. حاول مرة أخرى.",
      "Failed to create ad type. Please try again.": "فشل إنشاء نوع الإعلان. حاول مرة أخرى.",
      "Title is required and must be at least 3 characters long.": "العنوان مطلوب ويجب ألا يقل عن 3 أحرف.",
      "Title Arabic is required and must be at least 3 characters long.": "العنوان بالعربية مطلوب ويجب ألا يقل عن 3 أحرف.",
      "Active campaigns": "الحملات النشطة",
      "Ad Categories Report": "تقرير فئات الإعلانات",
      "Ad Distribution by Type": "توزيع الإعلانات حسب النوع",
      "Ad Types / Sections": "أنواع الإعلانات / الأقسام",
      "Ads per sub-type": "الإعلانات لكل نوع فرعي",
      "All cities": "جميع المدن",
      "All countries": "جميع الدول",
      "All statuses": "جميع الحالات",
      "Average session duration": "متوسط مدة الجلسة",
      "Average session in minutes (top 10 countries)": "متوسط الجلسة بالدقائق (أفضل 10 دول)",
      "Average spending per advertiser": "متوسط الإنفاق لكل مُعلن",
      "Average user rating": "متوسط تقييم المستخدم",
      "Avg. Minutes": "متوسط الدقائق",
      "Avg. Session Duration Per Country": "متوسط مدة الجلسة لكل دولة",
      "Balanced": "متوازن",
      "Balanced only": "المتوازن فقط",
      "Breakdown of ads per sub-type, with supply vs. demand overview": "تفصيل الإعلانات لكل نوع فرعي، مع نظرة عامة على العرض مقابل الطلب",
      "CTR": "نسبة النقر",
      "Categories Monitored": "الفئات المراقبة",
      "Communications": "التواصلات",
      "Conversion Funnel": "مسار التحويل",
      "Daily active users": "المستخدمون النشطون يوميًا",
      "Deficit Gaps": "فجوات العجز",
      "Deficit only": "العجز فقط",
      "Device distribution": "توزيع الأجهزة",
      "Distribution of advertising spending by package and category": "توزيع الإنفاق الإعلاني حسب الباقة والفئة",
      "Failed to load report": "فشل تحميل التقرير",
      "Foreign": "أجنبي",
      "Gap": "الفجوة",
      "Gross Revenue": "إجمالي الإيرادات",
      "Gross advertising revenues broken down by ad category": "إجمالي إيرادات الإعلانات مقسمة حسب تصنيف الإعلان",
      "Gross advertising revenues broken down by ad type": "إجمالي إيرادات الإعلانات مقسمة حسب نوع الإعلان",
      "Gross advertising revenues broken down by advertiser city": "إجمالي إيرادات الإعلانات مقسمة حسب مدينة المُعلن",
      "Gross advertising revenues broken down by advertiser country": "إجمالي إيرادات الإعلانات مقسمة حسب دولة المُعلن",
      "Item": "العنصر",
      "Items generating the highest engagement in this category": "العناصر التي تحقق أعلى تفاعل في هذه الفئة",
      "Key Strategic Gaps": "الفجوات الاستراتيجية الرئيسية",
      "Local": "محلي",
      "Local vs. Foreign Advertisers": "المُعلنون المحليون مقابل الأجانب",
      "Minutes": "الدقائق",
      "Monthly Ad Trend": "اتجاه الإعلانات الشهري",
      "New Ads": "إعلانات جديدة",
      "New This Period": "جديد هذه الفترة",
      "New users": "المستخدمون الجدد",
      "No advertiser data available": "لا توجد بيانات مُعلنين متاحة",
      "No categories": "لا توجد فئات",
      "No categories match your filters.": "لا توجد فئات تطابق عوامل التصفية.",
      "No category data available for this period": "لا توجد بيانات فئات متاحة لهذه الفترة",
      "No city data available for this period": "لا توجد بيانات مدن متاحة لهذه الفترة",
      "No country data available for this period": "لا توجد بيانات دول متاحة لهذه الفترة",
      "No device data available": "لا توجد بيانات أجهزة متاحة",
      "No funnel data available": "لا توجد بيانات مسار متاحة",
      "No item data available": "لا توجد بيانات عناصر متاحة",
      "No package data available": "لا توجد بيانات باقات متاحة",
      "No section data available for this period": "لا توجد بيانات أقسام متاحة لهذه الفترة",
      "No session data available": "لا توجد بيانات جلسات متاحة",
      "No supply or demand data found. Add some ads to categories first.": "لا توجد بيانات عرض أو طلب. أضف بعض الإعلانات إلى الفئات أولًا.",
      "No trend data available": "لا توجد بيانات اتجاهات متاحة",
      "No type data available": "لا توجد بيانات أنواع متاحة",
      "Number of ads for each category type": "عدد الإعلانات لكل نوع فئة",
      "Number of new ads posted each month over the past 12 months": "عدد الإعلانات الجديدة المنشورة كل شهر خلال الـ 12 شهرًا الماضية",
      "Overall ratio": "النسبة الإجمالية",
      "Package renewal rate": "معدل تجديد الباقات",
      "Ratio of advertisements from local versus foreign advertisers per country": "نسبة الإعلانات من المُعلنين المحليين مقابل الأجانب لكل دولة",
      "Refresh": "تحديث",
      "Refresh data": "تحديث البيانات",
      "Retry": "إعادة المحاولة",
      "Revenue": "الإيرادات",
      "Revenue breakdown": "تفصيل الإيرادات",
      "Revenue by Ad Type / Section": "الإيرادات حسب نوع الإعلان / القسم",
      "Revenue by Category": "الإيرادات حسب الفئة",
      "Revenue by City": "الإيرادات حسب المدينة",
      "Revenue by Country": "الإيرادات حسب الدولة",
      "Revenue by category": "الإيرادات حسب الفئة",
      "Revenue by package": "الإيرادات حسب الباقة",
      "Search category...": "ابحث عن فئة...",
      "Section": "القسم",
      "Select a category from the sidebar to view its stats": "اختر فئة من الشريط الجانبي لعرض إحصائياتها",
      "Share": "النسبة",
      "Spending": "الإنفاق",
      "Spending across ad packages": "الإنفاق عبر باقات الإعلانات",
      "Spending distribution across ad categories": "توزيع الإنفاق عبر فئات الإعلانات",
      "Supply & Demand Report": "تقرير العرض والطلب",
      "Supply (Offer)": "العرض",
      "Supply and demand matrix for all categories — sorted by gap size": "مصفوفة العرض والطلب لجميع الفئات — مرتبة حسب حجم الفجوة",
      "Supply vs. Demand": "العرض مقابل الطلب",
      "Supply/Demand Ratio": "نسبة العرض/الطلب",
      "Surplus Gaps": "فجوات الفائض",
      "Surplus only": "الفائض فقط",
      "Survival rate (30 days)": "معدل البقاء (30 يومًا)",
      "Switching from free to paid": "التحول من المجاني إلى المدفوع",
      "The largest advertisers on the platform, ranked by total amount paid": "أكبر المُعلنين على المنصة، مرتبين حسب إجمالي المبلغ المدفوع",
      "The server took too long to respond. Please try again.": "استغرق الخادم وقتًا طويلًا للرد. يرجى المحاولة مرة أخرى.",
      "Top 10 Most Reactive Items": "أفضل 10 عناصر تفاعلًا",
      "Top 10 highest-spending advertisers": "أفضل 10 مُعلنين إنفاقًا",
      "Top Country": "أعلى دولة",
      "Total Views": "إجمالي المشاهدات",
      "Total revenue": "إجمالي الإيرادات",
      "User classification by account type": "تصنيف المستخدمين حسب نوع الحساب",
      "User distribution by category": "توزيع المستخدمين حسب الفئة",
      "User journey from open to deal": "رحلة المستخدم من فتح الإعلان الى الصفقة",
      "Weekly active users": "المستخدمون النشطون أسبوعيًا",
      "ads": "إعلانات",
      "iOS vs. Android usage ratio": "نسبة استخدام نظام iOS مقابل نظام Android",
      "AMOUNT": "المبلغ",
      "About (Arabic)": "نبذة (بالعربية)",
      "About the influencer...": "نبذة عن المؤثر...",
      "Active Status": "حالة التفعيل",
      "Ad Package created successfully!": "تم إنشاء باقة الإعلان بنجاح!",
      "Ad Package deleted successfully!": "تم حذف باقة الإعلان بنجاح!",
      "Ad Package status updated successfully!": "تم تحديث حالة باقة الإعلان بنجاح!",
      "Ad Package updated successfully!": "تم تحديث باقة الإعلان بنجاح!",
      "Ad Payment": "دفع الإعلان",
      "Ad Refresh": "تحديث الإعلان",
      "Ad:": "إعلان:",
      "Add All Keywords": "إضافة كل الكلمات",
      "Add Banned Keyword": "إضافة كلمة محظورة",
      "Add Benefit": "إضافة ميزة",
      "Add Country Price Override": "إضافة سعر مخصص للدولة",
      "Add Keyword": "إضافة كلمة",
      "Add New Ad Package": "إضافة باقة إعلان جديدة",
      "Add New Influencer": "إضافة مؤثر جديد",
      "All Types": "جميع الأنواع",
      "Amount is required and must be greater than or equal to 0.": "المبلغ مطلوب ويجب أن يكون أكبر من أو يساوي 0.",
      "Android Version": "إصدار أندرويد",
      "Arabic": "العربية",
      "At least one benefit is required.": "مطلوب ميزة واحدة على الأقل.",
      "At least one benefit with both English and Arabic text is required.": "مطلوب ميزة واحدة على الأقل بنص إنجليزي وعربي.",
      "Auto-calculated from Amount ÷ Duration, but can be manually adjusted": "يُحسب تلقائيًا من المبلغ ÷ المدة، ويمكن تعديله يدويًا",
      "Auto-calculated from Amount/Duration": "يُحسب تلقائيًا من المبلغ/المدة",
      "BENEFITS COUNT": "عدد الميزات",
      "Banned keywords found": "تم العثور على كلمات محظورة",
      "Benefits": "المزايا",
      "Bulk Add": "إضافة جماعية",
      "Category Settings": "إعدادات الفئة",
      "Check Text": "فحص النص",
      "Checking...": "جارٍ الفحص...",
      "Comma or newline-separated. Duplicates skipped.": "مفصولة بفاصلة أو سطر جديد. يتم تجاهل التكرارات.",
      "Cover Image": "صورة الغلاف",
      "DAILY RATE": "المعدل اليومي",
      "DURATION": "المدة",
      "Daily Rate ($/day)": "المعدل اليومي ($/يوم)",
      "Default Amount ($)": "المبلغ الافتراضي ($)",
      "Default price:": "السعر الافتراضي:",
      "Duration (Days)": "المدة (أيام)",
      "Duration is required and must be at least 1 day.": "المدة مطلوبة ويجب ألا تقل عن يوم واحد.",
      "Edit Ad Package": "تعديل باقة الإعلان",
      "Edit Influencer": "تعديل المؤثر",
      "English": "الإنجليزية",
      "Enter Ad Refresh": "أدخل تحديث الإعلان",
      "Enter Amount": "أدخل المبلغ",
      "Enter Duration": "أدخل المدة",
      "Enter Email": "أدخل البريد الإلكتروني",
      "Enter Free Days": "أدخل الأيام المجانية",
      "Enter Location": "أدخل الموقع",
      "Enter Name": "أدخل الاسم",
      "Enter Name in Arabic": "أدخل الاسم بالعربية",
      "Enter Package Title": "أدخل عنوان الباقة",
      "Enter Package Title in Arabic": "أدخل عنوان الباقة بالعربية",
      "Enter Phone": "أدخل رقم الهاتف",
      "Enter Title": "أدخل العنوان",
      "Enter Title in Arabic": "أدخل العنوان بالعربية",
      "Enter benefit in Arabic": "أدخل الميزة بالعربية",
      "Enter benefit in English": "أدخل الميزة بالإنجليزية",
      "Enter reason for refund…": "أدخل سبب الاسترداد…",
      "Enter text to check": "أدخل النص للفحص",
      "Error loading ad packages": "خطأ في تحميل باقات الإعلانات",
      "Error loading banned keywords.": "خطأ في تحميل الكلمات المحظورة.",
      "Error loading influencers": "خطأ في تحميل المؤثرين",
      "Exporting…": "جارٍ التصدير…",
      "FREE DAYS": "الأيام المجانية",
      "Facebook": "فيسبوك",
      "Facebook URL": "رابط فيسبوك",
      "Failed to add keyword.": "فشل إضافة الكلمة.",
      "Failed to add keywords.": "فشل إضافة الكلمات.",
      "Failed to check text.": "فشل فحص النص.",
      "Failed to create ad package. Please try again.": "فشل إنشاء باقة الإعلان. يرجى المحاولة مرة أخرى.",
      "Failed to create influencer. Please try again.": "فشل إنشاء المؤثر. يرجى المحاولة مرة أخرى.",
      "Failed to delete ad package. Please try again.": "فشل حذف باقة الإعلان. يرجى المحاولة مرة أخرى.",
      "Failed to delete influencer. Please try again.": "فشل حذف المؤثر. يرجى المحاولة مرة أخرى.",
      "Failed to export. Please try again.": "فشل التصدير. يرجى المحاولة مرة أخرى.",
      "Failed to process refund.": "فشل معالجة الاسترداد.",
      "Failed to remove keyword.": "فشل إزالة الكلمة.",
      "Failed to save pricing.": "فشل حفظ التسعير.",
      "Failed to update ad package status. Please try again.": "فشل تحديث حالة باقة الإعلان. يرجى المحاولة مرة أخرى.",
      "Failed to update ad package. Please try again.": "فشل تحديث باقة الإعلان. يرجى المحاولة مرة أخرى.",
      "Failed to update influencer. Please try again.": "فشل تحديث المؤثر. يرجى المحاولة مرة أخرى.",
      "Failed to update settings.": "فشل تحديث الإعدادات.",
      "Fesilah Market": "سوق فسيلة",
      "Free Days (Bonus)": "الأيام المجانية (مكافأة)",
      "General": "عام",
      "Hide": "إخفاء",
      "IOS Version": "إصدار iOS",
      "Influencer created successfully!": "تم إنشاء المؤثر بنجاح!",
      "Influencer deleted successfully!": "تم حذف المؤثر بنجاح!",
      "Influencer updated successfully!": "تم تحديث المؤثر بنجاح!",
      "Instagram": "إنستغرام",
      "Instagram URL": "رابط إنستغرام",
      "Keyword": "الكلمة",
      "Keyword banned successfully.": "تم حظر الكلمة بنجاح.",
      "Keyword removed.": "تمت إزالة الكلمة.",
      "Keywords": "الكلمات",
      "Keywords added.": "تمت إضافة الكلمات.",
      "LOCATION": "الموقع",
      "Live": "مباشر",
      "Location (Arabic)": "الموقع (بالعربية)",
      "Monthly Revenue (Last 6 Months)": "الإيرادات الشهرية (آخر 6 أشهر)",
      "NAME": "الاسم",
      "NAME ARABIC": "الاسم بالعربية",
      "Name (Arabic) is required": "الاسم (بالعربية) مطلوب",
      "Name is required": "الاسم مطلوب",
      "No ad packages found": "لا توجد باقات إعلانات",
      "No banned keywords yet.": "لا توجد كلمات محظورة بعد.",
      "No country-specific prices yet. All users will see the default price.": "لا توجد أسعار خاصة بالدول بعد. سيرى جميع المستخدمين السعر الافتراضي.",
      "No influencers found": "لا يوجد مؤثرون",
      "No transactions found": "لا توجد معاملات",
      "Paste an ad title or description here to check for banned words...": "الصق عنوان أو وصف إعلان هنا للتحقق من الكلمات المحظورة...",
      "Pay:": "دفع:",
      "Payment": "الدفع",
      "Payment Mode": "وضع الدفع",
      "Please select a country.": "يرجى اختيار دولة.",
      "Popup Message": "رسالة النافذة المنبثقة",
      "Popup Message Arabic": "رسالة النافذة المنبثقة بالعربية",
      "Price ($)": "السعر ($)",
      "Pricing by Country": "التسعير حسب الدولة",
      "Pricing saved successfully!": "تم حفظ التسعير بنجاح!",
      "Process Refund": "معالجة الاسترداد",
      "Profile Icon": "أيقونة الملف الشخصي",
      "RECOMMENDED": "موصى به",
      "ROLE": "الدور",
      "Recommended": "موصى به",
      "Recommended Package": "الباقة الموصى بها",
      "Refund": "استرداد",
      "Refund Reason (optional)": "سبب الاسترداد (اختياري)",
      "Refund processed successfully.": "تمت معالجة الاسترداد بنجاح.",
      "Refunding": "جارٍ استرداد",
      "Remove": "إزالة",
      "Role": "الدور",
      "Role (Arabic)": "الدور (بالعربية)",
      "Save Pricing": "حفظ التسعير",
      "Save Settings": "حفظ الإعدادات",
      "Saving…": "جارٍ الحفظ…",
      "Search Ad Package Title..": "ابحث عن عنوان باقة الإعلان..",
      "Search Influencer Name..": "ابحث عن اسم المؤثر..",
      "Search keywords...": "ابحث في الكلمات...",
      "Search user, email…": "ابحث عن مستخدم أو بريد إلكتروني…",
      "Select country…": "اختر دولة…",
      "Settings updated successfully!": "تم تحديث الإعدادات بنجاح!",
      "Show": "إظهار",
      "Single Add": "إضافة فردية",
      "Snapchat": "سناب شات",
      "Snapchat URL": "رابط سناب شات",
      "Social Media Links": "روابط التواصل الاجتماعي",
      "Status updated successfully!": "تم تحديث الحالة بنجاح!",
      "Stored lowercase. Checked in ad title & description.": "تُخزّن بأحرف صغيرة. يتم فحصها في عنوان ووصف الإعلان.",
      "Subscription": "اشتراك",
      "Test": "تجريبي",
      "Test Text": "نص تجريبي",
      "Text is clean": "النص نظيف",
      "Threads": "ثريدز",
      "Threads URL": "رابط ثريدز",
      "TikTok": "تيك توك",
      "TikTok URL": "رابط تيك توك",
      "Total Refunded": "إجمالي المسترد",
      "Update Settings": "تحديث الإعدادات",
      "Update failed": "فشل التحديث",
      "Used when no country-specific price is set": "يُستخدم عند عدم تعيين سعر خاص بالدولة",
      "Version Popup Title": "عنوان نافذة الإصدار",
      "Version Title Arabic": "عنوان الإصدار بالعربية",
      "Voucher": "قسيمة",
      "Wallet Credit": "إيداع المحفظة",
      "Wallet Debit": "خصم المحفظة",
      "Wallet Transactions": "معاملات المحفظة",
      "YouTube": "يوتيوب",
      "YouTube URL": "رابط يوتيوب",
      "applied when no country-specific price is set.": "يُطبّق عند عدم تعيين سعر خاص بالدولة.",
      "day": "يوم",
      "e.g. Farmer, Expert": "مثال: مزارع، خبير",
      "e.g. spam, fake, scam": "مثال: سبام، مزيف، احتيال",
      "e.g. مزارع، خبير": "مثال: مزارع، خبير",
      "for": "لـ",
      "keyword banned": "كلمة محظورة",
      "keywords banned": "كلمات محظورة",
      "pending": "معلق",
      "records": "سجلات",
      "refunds": "استردادات",
      "transactions": "معاملات",
      "transactions · incl. wallet": "معاملات · شاملة المحفظة",
      "vs. Default": "مقابل الافتراضي",
      "أدخل الموقع": "أدخل الموقع",
      "نبذة عن المؤثر...": "نبذة عن المؤثر...",
      "● Live payments are active": "● المدفوعات المباشرة نشطة",
      "● Test mode — no real charges": "● الوضع التجريبي — لا رسوم فعلية",
      "Activated By": "تم التفعيل بواسطة",
      "Activation Date": "تاريخ التفعيل",
      "Ad": "الإعلان",
      "Ad Category created successfully!": "تم إنشاء فئة الإعلان بنجاح!",
      "Ad Category deleted successfully!": "تم حذف فئة الإعلان بنجاح!",
      "Ad Category status updated successfully!": "تم تحديث حالة فئة الإعلان بنجاح!",
      "Ad Category updated successfully!": "تم تحديث فئة الإعلان بنجاح!",
      "Ad ID": "معرّف الإعلان",
      "Add Another Type": "إضافة نوع آخر",
      "Add Category Type": "إضافة نوع فئة",
      "Add Custom Field": "إضافة حقل مخصص",
      "Add Custom Filter": "إضافة فلتر مخصص",
      "Add New": "إضافة جديد",
      "Add New Ad Category": "إضافة فئة إعلان جديدة",
      "Add New Subcategory": "إضافة فئة فرعية جديدة",
      "Add Option": "إضافة خيار",
      "Add Promo Code": "إضافة كود خصم",
      "All fields (English & Arabic) are required for all types.": "جميع الحقول (بالإنجليزية والعربية) مطلوبة لكل الأنواع.",
      "All options must have both English and Arabic values": "يجب أن تحتوي جميع الخيارات على قيم بالإنجليزية والعربية",
      "All options must have both English and Arabic values!": "يجب أن تحتوي جميع الخيارات على قيم بالإنجليزية والعربية!",
      "Any date": "أي تاريخ",
      "Applicable To": "ينطبق على",
      "Approve": "موافقة",
      "Approve Review": "الموافقة على المراجعة",
      "Arabic Label": "التسمية بالعربية",
      "Are you sure you want to delete this category type?": "هل أنت متأكد أنك تريد حذف نوع الفئة هذا؟",
      "Are you sure you want to delete this custom field?": "هل أنت متأكد أنك تريد حذف هذا الحقل المخصص؟",
      "Are you sure you want to delete this custom filter?": "هل أنت متأكد أنك تريد حذف هذا الفلتر المخصص؟",
      "Are you sure you want to mark this review as": "هل أنت متأكد أنك تريد تعيين هذه المراجعة كـ",
      "Assigned Users": "المستخدمون المعيّنون",
      "At least one user must be selected.": "يجب اختيار مستخدم واحد على الأقل.",
      "Avg. Discount / Use": "متوسط الخصم / الاستخدام",
      "Back to Batches": "العودة إلى الدفعات",
      "Back to Categories": "العودة إلى الفئات",
      "Back to List": "العودة إلى القائمة",
      "Batch Name": "اسم الدفعة",
      "Batch Name (Arabic)": "اسم الدفعة (بالعربية)",
      "Batch Vouchers": "قسائم الدفعة",
      "Batch created successfully!": "تم إنشاء الدفعة بنجاح!",
      "Batch updated successfully!": "تم تحديث الدفعة بنجاح!",
      "Before today": "قبل اليوم",
      "Card Value": "قيمة البطاقة",
      "Category Icon": "أيقونة الفئة",
      "Category Types": "أنواع الفئات",
      "Category Types for:": "أنواع الفئات لـ:",
      "Category type created successfully": "تم إنشاء نوع الفئة بنجاح",
      "Category type deleted successfully": "تم حذف نوع الفئة بنجاح",
      "Category type updated successfully": "تم تحديث نوع الفئة بنجاح",
      "Checkbox": "مربع اختيار",
      "City list": "قائمة المدن",
      "Code": "الكود",
      "Comment": "التعليق",
      "Country list": "قائمة الدول",
      "Coupon Code": "كود الكوبون",
      "Coupon Type": "نوع الكوبون",
      "Currency list": "قائمة العملات",
      "Custom Fields": "الحقول المخصصة",
      "Custom Fields for:": "الحقول المخصصة لـ:",
      "Custom Filters": "الفلاتر المخصصة",
      "Custom Filters for:": "الفلاتر المخصصة لـ:",
      "Custom field created successfully!": "تم إنشاء الحقل المخصص بنجاح!",
      "Custom field deleted successfully!": "تم حذف الحقل المخصص بنجاح!",
      "Custom field updated successfully!": "تم تحديث الحقل المخصص بنجاح!",
      "Custom filter created successfully": "تم إنشاء الفلتر المخصص بنجاح",
      "Custom filter deleted successfully": "تم حذف الفلتر المخصص بنجاح",
      "Custom filter updated successfully": "تم تحديث الفلتر المخصص بنجاح",
      "Customer": "العميل",
      "Date Created": "تاريخ الإنشاء",
      "Delete Category Type": "حذف نوع الفئة",
      "Delete Custom Field": "حذف الحقل المخصص",
      "Delete Custom Filter": "حذف الفلتر المخصص",
      "Demand": "طلب",
      "Description (AR)": "الوصف (بالعربية)",
      "Description (EN)": "الوصف (بالإنجليزية)",
      "Description (English)": "الوصف (بالإنجليزية)",
      "Discount": "الخصم",
      "Discount Type": "نوع الخصم",
      "Discount Value": "قيمة الخصم",
      "Dropdown (Multiple)": "قائمة منسدلة (متعددة)",
      "Dropdown (Single)": "قائمة منسدلة (فردية)",
      "Dropdown Multiple": "قائمة منسدلة متعددة",
      "Dropdown Single": "قائمة منسدلة فردية",
      "Edit Ad Category": "تعديل فئة الإعلان",
      "Edit Batch": "تعديل الدفعة",
      "Edit Batch Details": "تعديل تفاصيل الدفعة",
      "Edit Category Type": "تعديل نوع الفئة",
      "Edit Custom Field": "تعديل الحقل المخصص",
      "Edit Custom Filter": "تعديل الفلتر المخصص",
      "Edit Promo Code": "تعديل كود الخصم",
      "Edit Promo Code Details": "تعديل تفاصيل كود الخصم",
      "English Label": "التسمية بالإنجليزية",
      "Enter Category Description": "أدخل وصف الفئة",
      "Enter Category Description in Arabic": "أدخل وصف الفئة بالعربية",
      "Enter description in Arabic": "أدخل الوصف بالعربية",
      "Enter description in English": "أدخل الوصف بالإنجليزية",
      "Enter field name in Arabic": "أدخل اسم الحقل بالعربية",
      "Enter field name in English": "أدخل اسم الحقل بالإنجليزية",
      "Enter filter name in Arabic": "أدخل اسم الفلتر بالعربية",
      "Enter filter name in English": "أدخل اسم الفلتر بالإنجليزية",
      "Enter title in Arabic": "أدخل العنوان بالعربية",
      "Enter title in English": "أدخل العنوان بالإنجليزية",
      "Error loading ad categories": "خطأ في تحميل فئات الإعلانات",
      "Error loading promo codes": "خطأ في تحميل أكواد الخصم",
      "Error loading review details": "خطأ في تحميل تفاصيل المراجعة",
      "Error loading vouchers": "خطأ في تحميل القسائم",
      "Expired At": "تنتهي في",
      "Expiry": "انتهاء الصلاحية",
      "Expiry Date": "تاريخ انتهاء الصلاحية",
      "Expiry Type": "نوع انتهاء الصلاحية",
      "Export to Excel": "تصدير إلى Excel",
      "FEATURES COUNT": "عدد الميزات",
      "Failed to create ad category. Please try again.": "فشل إنشاء فئة الإعلان. يرجى المحاولة مرة أخرى.",
      "Failed to delete ad category. Please try again.": "فشل حذف فئة الإعلان. يرجى المحاولة مرة أخرى.",
      "Failed to delete category type. Please try again.": "فشل حذف نوع الفئة. يرجى المحاولة مرة أخرى.",
      "Failed to delete custom field. Please try again.": "فشل حذف الحقل المخصص. يرجى المحاولة مرة أخرى.",
      "Failed to delete custom filter. Please try again.": "فشل حذف الفلتر المخصص. يرجى المحاولة مرة أخرى.",
      "Failed to delete promo code.": "فشل حذف كود الخصم.",
      "Failed to delete strategic ad type": "فشل حذف نوع الإعلان الاستراتيجي",
      "Failed to save batch. Please try again.": "فشل حفظ الدفعة. يرجى المحاولة مرة أخرى.",
      "Failed to save category type. Please try again.": "فشل حفظ نوع الفئة. يرجى المحاولة مرة أخرى.",
      "Failed to save custom field. Please try again.": "فشل حفظ الحقل المخصص. يرجى المحاولة مرة أخرى.",
      "Failed to save custom filter. Please try again.": "فشل حفظ الفلتر المخصص. يرجى المحاولة مرة أخرى.",
      "Failed to save promo code.": "فشل حفظ كود الخصم.",
      "Failed to save strategic ad types. Please try again.": "فشل حفظ أنواع الإعلانات الاستراتيجية. يرجى المحاولة مرة أخرى.",
      "Failed to update ad category status. Please try again.": "فشل تحديث حالة فئة الإعلان. يرجى المحاولة مرة أخرى.",
      "Failed to update ad category. Please try again.": "فشل تحديث فئة الإعلان. يرجى المحاولة مرة أخرى.",
      "Failed to update review status. Please try again.": "فشل تحديث حالة المراجعة. يرجى المحاولة مرة أخرى.",
      "Failed to update status. Please try again.": "فشل تحديث الحالة. يرجى المحاولة مرة أخرى.",
      "Field Key": "مفتاح الحقل",
      "Field Name (AR)": "اسم الحقل (بالعربية)",
      "Field Name (EN)": "اسم الحقل (بالإنجليزية)",
      "Field Type": "نوع الحقل",
      "Field name (English and Arabic) is required!": "اسم الحقل (بالإنجليزية والعربية) مطلوب!",
      "File (Multiple)": "ملف (متعدد)",
      "File (Single)": "ملف (فردي)",
      "Filter Key": "مفتاح الفلتر",
      "Filter Name (AR)": "اسم الفلتر (بالعربية)",
      "Filter Name (Arabic)": "اسم الفلتر (بالعربية)",
      "Filter Name (EN)": "اسم الفلتر (بالإنجليزية)",
      "Filter Name (English)": "اسم الفلتر (بالإنجليزية)",
      "Filter Type": "نوع الفلتر",
      "Filter name (English and Arabic) is required": "اسم الفلتر (بالإنجليزية والعربية) مطلوب",
      "Fixed": "ثابت",
      "Fixed Amount": "مبلغ ثابت",
      "For Employer": "لصاحب العمل",
      "For Job Seeker": "للباحث عن عمل",
      "Future only": "المستقبل فقط",
      "ICON": "الأيقونة",
      "Icon": "الأيقونة",
      "Is Required?": "مطلوب؟",
      "Key": "المفتاح",
      "Leave empty for no cap": "اتركه فارغًا لعدم وجود حد أقصى",
      "Leave empty for no minimum": "اتركه فارغًا لعدم وجود حد أدنى",
      "Leave empty for unlimited": "اتركه فارغًا لغير محدود",
      "Listing Type": "نوع الإدراج",
      "Manage Strategic Ad Types": "إدارة أنواع الإعلانات الاستراتيجية",
      "Manage custom fields for this ad category": "إدارة الحقول المخصصة لفئة الإعلان هذه",
      "Manage custom filters for this ad category": "إدارة الفلاتر المخصصة لفئة الإعلان هذه",
      "Manage types for this ad category": "إدارة الأنواع لفئة الإعلان هذه",
      "Max": "الحد الأقصى",
      "Max Characters": "الحد الأقصى للأحرف",
      "Max Discount": "أقصى خصم",
      "Max Value": "القيمة القصوى",
      "Max characters cannot be less than min characters": "لا يمكن أن يكون الحد الأقصى للأحرف أقل من الحد الأدنى",
      "Max times a single customer can use this code.": "أقصى عدد مرات يمكن لعميل واحد استخدام هذا الكود.",
      "Max value cannot be less than min value": "لا يمكن أن تكون القيمة القصوى أقل من القيمة الدنيا",
      "Maximum Discount Amount": "أقصى مبلغ خصم",
      "Maximum Usage Count": "أقصى عدد استخدامات",
      "Min": "الحد الأدنى",
      "Min Characters": "الحد الأدنى للأحرف",
      "Min Order": "أقل طلب",
      "Min Value": "القيمة الدنيا",
      "Minimum Order Amount": "أدنى مبلغ للطلب",
      "Must be unique. Letters and numbers only.": "يجب أن يكون فريدًا. أحرف وأرقام فقط.",
      "New": "جديد",
      "New Batch Details": "تفاصيل الدفعة الجديدة",
      "New Promo Code Details": "تفاصيل كود الخصم الجديد",
      "New Users": "المستخدمون الجدد",
      "No ad categories found": "لا توجد فئات إعلانات",
      "No category types found. Click \"Add Category Type\" to create one.": "لا توجد أنواع فئات. انقر على \"إضافة نوع فئة\" لإنشاء واحد.",
      "No comment provided": "لم يتم تقديم تعليق",
      "No custom fields found. Click \"Add Custom Field\" to create one.": "لا توجد حقول مخصصة. انقر على \"إضافة حقل مخصص\" لإنشاء واحد.",
      "No custom filters found. Click \"Add Custom Filter\" to create one.": "لا توجد فلاتر مخصصة. انقر على \"إضافة فلتر مخصص\" لإنشاء واحد.",
      "No max characters": "بدون حد أقصى للأحرف",
      "No max value": "لا توجد قيمة قصوى",
      "No min characters": "بدون حد أدنى للأحرف",
      "No min value": "لا توجد قيمة دنيا",
      "No promo codes found": "لا توجد أكواد خصم",
      "No redemptions yet": "لا توجد استردادات بعد",
      "No restriction": "بدون قيود",
      "No reviews found": "لا توجد مراجعات",
      "No vouchers found": "لا توجد قسائم",
      "Number": "رقم",
      "Off": "خصم",
      "Old Users": "المستخدمون القدامى",
      "Option (AR)": "الخيار (بالعربية)",
      "Option (EN)": "الخيار (بالإنجليزية)",
      "Options": "الخيارات",
      "Order / Ref": "الطلب / المرجع",
      "Parent Category": "الفئة الرئيسية",
      "Past only": "الماضي فقط",
      "Percentage": "نسبة مئوية",
      "Please add at least one option for dropdown/radio fields!": "يرجى إضافة خيار واحد على الأقل للقوائم المنسدلة/أزرار الاختيار!",
      "Please add at least one option for dropdown/radio/checkbox filters": "يرجى إضافة خيار واحد على الأقل لفلاتر القوائم المنسدلة/أزرار الاختيار/مربعات الاختيار",
      "Posted On": "نُشر في",
      "Promo Code": "كود الخصم",
      "Promo Code Details": "تفاصيل كود الخصم",
      "Promo Details": "تفاصيل الخصم",
      "Promo code created successfully!": "تم إنشاء كود الخصم بنجاح!",
      "Promo code deleted successfully!": "تم حذف كود الخصم بنجاح!",
      "Promo code not found.": "كود الخصم غير موجود.",
      "Promo code updated successfully!": "تم تحديث كود الخصم بنجاح!",
      "Quantity cannot be changed after creation.": "لا يمكن تغيير الكمية بعد الإنشاء.",
      "Radio": "زر اختيار",
      "Range": "نطاق",
      "Redemption History": "سجل الاسترداد",
      "Redemption Rate": "معدل الاسترداد",
      "Reject": "رفض",
      "Reject Review": "رفض المراجعة",
      "Remove Type": "إزالة النوع",
      "Required": "مطلوب",
      "Review Content": "محتوى المراجعة",
      "Review Details": "تفاصيل المراجعة",
      "Review not found": "المراجعة غير موجودة",
      "Review status updated successfully!": "تم تحديث حالة المراجعة بنجاح!",
      "Reviews": "المراجعات",
      "Save Changes": "حفظ التغييرات",
      "Search Reviews...": "ابحث في المراجعات...",
      "Search Voucher ID...": "ابحث بمعرّف القسيمة...",
      "Search by title or code...": "ابحث بالعنوان أو الكود...",
      "Search users by name, email or phone...": "ابحث عن المستخدمين بالاسم أو البريد الإلكتروني أو الهاتف...",
      "Select Key": "اختر المفتاح",
      "Select Users": "اختر المستخدمين",
      "Select expiry date": "اختر تاريخ انتهاء الصلاحية",
      "Stars": "النجوم",
      "Status updated successfully": "تم تحديث الحالة بنجاح",
      "Strategic Type": "نوع استراتيجي",
      "Strategic ad type deleted successfully": "تم حذف نوع الإعلان الاستراتيجي بنجاح",
      "Strategic ad types saved successfully!": "تم حفظ أنواع الإعلانات الاستراتيجية بنجاح!",
      "Subcategories": "الفئات الفرعية",
      "Subcategories of": "الفئات الفرعية لـ",
      "Subcategory": "فئة فرعية",
      "Supply": "عرض",
      "TITLE ARABIC": "العنوان بالعربية",
      "Text": "نص",
      "Textarea": "منطقة نص",
      "Title (AR)": "العنوان (بالعربية)",
      "Title (EN)": "العنوان (بالإنجليزية)",
      "Title (English and Arabic) is required": "العنوان (بالإنجليزية والعربية) مطلوب",
      "Today and onwards": "اليوم وما بعده",
      "Total Activated": "إجمالي المفعّلة",
      "Total Discount Given": "إجمالي الخصم الممنوح",
      "Total Issued": "إجمالي الصادر",
      "Total Redeemed Value": "إجمالي القيمة المستردة",
      "Total Redemptions": "إجمالي الاستردادات",
      "Type": "النوع",
      "Type Description": "وصف النوع",
      "Type Description (Arabic)": "وصف النوع (بالعربية)",
      "Type Title": "عنوان النوع",
      "Type Title (Arabic)": "عنوان النوع (بالعربية)",
      "Type at least 2 characters to search": "اكتب حرفين على الأقل للبحث",
      "Types": "الأنواع",
      "Unique Customers": "العملاء الفريدون",
      "Unlimited": "غير محدود",
      "Update Status": "تحديث الحالة",
      "Usage / Customer": "الاستخدام / العميل",
      "Usage Count": "عدد الاستخدامات",
      "Usage Limit Per Customer": "حد الاستخدام لكل عميل",
      "Used": "مستخدم",
      "Used At": "استُخدم في",
      "User ID": "معرّف المستخدم",
      "Value cannot be changed after creation.": "لا يمكن تغيير القيمة بعد الإنشاء.",
      "Voucher Code": "كود القسيمة",
      "Voucher ID": "معرّف القسيمة",
      "Vouchers": "القسائم",
      "Yes,": "نعم،",
      "You want to delete this strategic ad type?": "هل تريد حذف نوع الإعلان الاستراتيجي هذا؟",
      "active": "نشط",
      "e.g. Dubai Expo 2025": "مثال: إكسبو دبي 2025",
      "e.g. Summer Sale": "مثال: تخفيضات الصيف",
      "e.g. تخفيض الصيف": "مثال: تخفيض الصيف",
      "fixed": "ثابت",
      "total uses": "إجمالي الاستخدامات",
      "uses max": "أقصى عدد استخدامات",
      "% of Total Visits": "٪ من إجمالي الزيارات",
      "1–5 minutes": "١–٥ دقائق",
      "ACTIONS": "الإجراءات",
      "AD ID": "معرّف الإعلان",
      "Account Type Breakdown": "توزيع أنواع الحسابات",
      "Accounts": "الحسابات",
      "Activation Rate": "معدل التفعيل",
      "Active Ads": "الإعلانات النشطة",
      "Active Campaigns": "الحملات النشطة",
      "Active Cards": "البطاقات النشطة",
      "Active Countries": "الدول النشطة",
      "Active Users": "المستخدمون النشطون",
      "Ad Revenue": "إيرادات الإعلانات",
      "Ad Title": "عنوان الإعلان",
      "Ad deleted successfully!": "تم حذف الإعلان بنجاح!",
      "Add New Batch": "إضافة دفعة جديدة",
      "Ads Published": "الإعلانات المنشورة",
      "Ads published per month": "الإعلانات المنشورة شهريًا",
      "Advertiser": "المُعلن",
      "All Ads": "جميع الإعلانات",
      "All Categories": "جميع الفئات",
      "All Methods": "جميع الطرق",
      "All Status": "جميع الحالات",
      "Amount": "المبلغ",
      "Apple Pay": "Apple Pay",
      "Apply": "تطبيق",
      "Applying…": "جارٍ التطبيق…",
      "Average CTR": "متوسط نسبة النقر",
      "Average time per visit": "متوسط الوقت لكل زيارة",
      "Avg. CTR": "متوسط نسبة النقر",
      "Avg. Session": "متوسط الجلسة",
      "Avg. Spend / Advertiser": "متوسط الإنفاق / المُعلن",
      "Avg. Time Spent": "متوسط الوقت المستغرق",
      "Batch ID": "معرّف الدفعة",
      "Batch deleted successfully!": "تم حذف الدفعة بنجاح!",
      "Bulk action applied!": "تم تطبيق الإجراء الجماعي!",
      "Bulk action failed. Please try again.": "فشل الإجراء الجماعي. يرجى المحاولة مرة أخرى.",
      "CATEGORY": "الفئة",
      "CITY": "المدينة",
      "CLICKS": "النقرات",
      "COUNTRY": "الدولة",
      "CREATED DATE": "تاريخ الإنشاء",
      "Card": "بطاقة",
      "Change Status…": "تغيير الحالة…",
      "Clicks": "النقرات",
      "Completed": "مكتمل",
      "Completed Ads": "الإعلانات المكتملة",
      "Count": "العدد",
      "Country / City": "الدولة / المدينة",
      "Currently active": "نشط حاليًا",
      "DAU": "المستخدمون النشطون يوميًا",
      "Daily Active Users": "المستخدمون النشطون يوميًا",
      "Date": "التاريخ",
      "Deselect All": "إلغاء تحديد الكل",
      "Deselect all on this page": "إلغاء تحديد الكل في هذه الصفحة",
      "Distribution of ads per category": "توزيع الإعلانات لكل فئة",
      "Distribution of registered users by account type": "توزيع المستخدمين المسجلين حسب نوع الحساب",
      "Draft": "مسودة",
      "Error loading ads": "خطأ في تحميل الإعلانات",
      "Error loading batches": "خطأ في تحميل الدفعات",
      "Expired Cards": "البطاقات المنتهية",
      "Failed": "فشل",
      "Failed to delete ad. Please try again.": "فشل حذف الإعلان. يرجى المحاولة مرة أخرى.",
      "Failed to delete batch. Please try again.": "فشل حذف الدفعة. يرجى المحاولة مرة أخرى.",
      "Fesilah Wallet": "محفظة فسيلة",
      "Free Ads": "الإعلانات المجانية",
      "Free → Paid Rate": "معدل التحول من مجاني إلى مدفوع",
      "Highest performing ads by views": "أعلى الإعلانات أداءً حسب المشاهدات",
      "Inactive / Unused Cards": "البطاقات غير النشطة / غير المستخدمة",
      "Joined": "تاريخ الانضمام",
      "LANGUAGE": "اللغة",
      "MAU": "المستخدمون النشطون شهريًا",
      "Manual": "يدوي",
      "Monthly Active Users": "المستخدمون النشطون شهريًا",
      "Monthly Ads": "الإعلانات الشهرية",
      "Most Active Sections & Pages": "الأقسام والصفحات الأكثر نشاطًا",
      "Most active cities by user count": "المدن الأكثر نشاطًا حسب عدد المستخدمين",
      "No ads found": "لا توجد إعلانات",
      "No advertisers found": "لا يوجد مُعلنون",
      "No batches found": "لا توجد دفعات",
      "No category data available": "لا توجد بيانات فئات متاحة",
      "No city data available": "لا توجد بيانات مدن متاحة",
      "No country data available": "لا توجد بيانات دول متاحة",
      "No data": "لا توجد بيانات",
      "No page visit data available yet": "لا توجد بيانات زيارات للصفحات بعد",
      "No payment records found": "لا توجد سجلات دفع",
      "No performance data available for the selected period": "لا توجد بيانات أداء متاحة للفترة المحددة",
      "No previous month data": "لا توجد بيانات للشهر السابق",
      "No trend data yet": "لا توجد بيانات اتجاه بعد",
      "No trending ads data available yet": "لا توجد بيانات إعلانات رائجة بعد",
      "Online Now": "متصل الآن",
      "Over 10 min": "أكثر من ١٠ دقائق",
      "PAID AMOUNT": "المبلغ المدفوع",
      "Package Renewal Rate": "معدل تجديد الباقات",
      "Payment Date Range": "نطاق تاريخ الدفع",
      "Payment Records": "سجلات الدفع",
      "Peak Activity Hours": "ساعات الذروة",
      "Pending Ads": "الإعلانات المعلقة",
      "Performance": "الأداء",
      "Performance report for the selected period": "تقرير الأداء للفترة المحددة",
      "Period": "الفترة",
      "Please select a status to apply.": "يرجى اختيار حالة للتطبيق.",
      "Please select at least one ad.": "يرجى اختيار إعلان واحد على الأقل.",
      "Posted By": "نُشر بواسطة",
      "Quantity": "الكمية",
      "Ranked by visit volume with average time spent": "مرتبة حسب حجم الزيارات مع متوسط الوقت المستغرق",
      "Refunded": "مسترد",
      "Rejected": "مرفوض",
      "Rejected Ads": "الإعلانات المرفوضة",
      "Rejection reason (optional)": "سبب الرفض (اختياري)",
      "Retention Rate": "معدل الاحتفاظ",
      "STATUS": "الحالة",
      "Search Ad Title..": "ابحث عن عنوان الإعلان..",
      "Search Batch Name/ID...": "ابحث باسم/معرّف الدفعة...",
      "Search advertiser…": "ابحث عن مُعلن…",
      "Search name, email…": "ابحث بالاسم أو البريد الإلكتروني…",
      "Section / Page": "القسم / الصفحة",
      "Select all on this page": "تحديد الكل في هذه الصفحة",
      "Session Duration": "مدة الجلسة",
      "Shares": "المشاركات",
      "Strategic Ads": "الإعلانات الاستراتيجية",
      "Stripe": "Stripe",
      "TITLE": "العنوان",
      "TYPE": "النوع",
      "This Month": "هذا الشهر",
      "This Week": "هذا الأسبوع",
      "This month vs last": "هذا الشهر مقابل الماضي",
      "This week vs last": "هذا الأسبوع مقابل الماضي",
      "Today": "اليوم",
      "Today vs yesterday": "اليوم مقابل الأمس",
      "Today's Ads": "إعلانات اليوم",
      "Top 10 Cities": "أفضل ١٠ مدن",
      "Top 10 Countries": "أفضل ١٠ دول",
      "Top 10 Highest-Spending Advertisers": "أفضل ١٠ مُعلنين إنفاقًا",
      "Top Categories by Ads": "أهم الفئات حسب الإعلانات",
      "Top Trending Ads": "أهم الإعلانات الرائجة",
      "Total Ad Revenue (This Year)": "إجمالي إيرادات الإعلانات (هذا العام)",
      "Total Ads": "إجمالي الإعلانات",
      "Total Advertisers": "إجمالي المُعلنين",
      "Total Cards Issued": "إجمالي البطاقات الصادرة",
      "Total Packages": "إجمالي الباقات",
      "Total Paid": "إجمالي المدفوع",
      "Total Revenue": "إجمالي الإيرادات",
      "Total Spending": "إجمالي الإنفاق",
      "Total Users": "إجمالي المستخدمين",
      "Total:": "الإجمالي:",
      "Trade Dashboard": "لوحة تحكم التجارة",
      "USER": "المستخدم",
      "Under 1 min": "أقل من دقيقة",
      "Unique users per hour of day": "المستخدمون الفريدون لكل ساعة من اليوم",
      "Unique users who opened the app": "المستخدمون الفريدون الذين فتحوا التطبيق",
      "Users by country of registration": "المستخدمون حسب دولة التسجيل",
      "Users who returned this month": "المستخدمون الذين عادوا هذا الشهر",
      "VIEWS": "المشاهدات",
      "Value": "القيمة",
      "View Details": "عرض التفاصيل",
      "View Vouchers": "عرض القسائم",
      "Views": "المشاهدات",
      "WAU": "المستخدمون النشطون أسبوعيًا",
      "Weekly Active Users": "المستخدمون النشطون أسبوعيًا",
      "ad payment records": "سجلات دفع الإعلانات",
      "ad selected": "إعلان محدد",
      "ads selected": "إعلانات محددة",
      "is peak": "هي الذروة",
      "online now": "متصل الآن",
      "per visit": "لكل زيارة",
      "this month": "هذا الشهر",
      "total": "الإجمالي",
      "total sessions": "إجمالي الجلسات",
      "unique advertisers": "مُعلن فريد",
      "unique users who posted at least 1 ad": "مستخدمون فريدون نشروا إعلانًا واحدًا على الأقل",
      "visits": "زيارة",
      "vs last month": "مقابل الشهر الماضي",
      "vs last week": "مقابل الأسبوع الماضي",
      "vs yesterday": "مقابل الأمس",
      // ── System Users / Roles / Permissions / Activity Logs / Account ──
      "Add New User": "إضافة مستخدم جديد",
      "Search Name or Email..": "ابحث بالاسم أو البريد الإلكتروني..",
      "Error loading system users": "خطأ في تحميل مستخدمي النظام",
      "system-users": "مستخدمو النظام",
      "Edit System User": "تعديل مستخدم النظام",
      "Add New System User": "إضافة مستخدم نظام جديد",
      "User Name": "اسم المستخدم",
      "Enter System User Name": "أدخل اسم مستخدم النظام",
      "User Email": "البريد الإلكتروني للمستخدم",
      "Enter System User Email": "أدخل البريد الإلكتروني لمستخدم النظام",
      "Leave blank to keep current password": "اتركه فارغًا للاحتفاظ بكلمة المرور الحالية",
      "Enter System User Password": "أدخل كلمة مرور مستخدم النظام",
      "User Phone No": "رقم هاتف المستخدم",
      "Enter System User Phone": "أدخل رقم هاتف مستخدم النظام",
      "User Role": "دور المستخدم",
      "Select Role": "اختر الدور",
      "Add New Role": "إضافة دور جديد",
      "Search Role Name..": "ابحث باسم الدور..",
      "Error loading roles": "خطأ في تحميل الأدوار",
      "roles": "الأدوار",
      "Edit Role": "تعديل الدور",
      "Role Name": "اسم الدور",
      "Enter Role Name": "أدخل اسم الدور",
      "Role Permissions": "صلاحيات الدور",
      "Role:": "الدور:",
      "Are you sure you want to update permissions for this role?": "هل أنت متأكد أنك تريد تحديث صلاحيات هذا الدور؟",
      "Update Permissions": "تحديث الصلاحيات",
      "Permissions": "الصلاحيات",
      "Search Permission Name..": "ابحث باسم الصلاحية..",
      "Error loading permissions": "خطأ في تحميل الصلاحيات",
      "permissions": "الصلاحيات",
      "All Modules": "جميع الوحدات",
      "All Actions": "جميع الإجراءات",
      "Status Update": "تحديث الحالة",
      "Clear Filters": "مسح عوامل التصفية",
      "Module": "الوحدة",
      "Performed By": "بواسطة",
      "Ref ID": "المعرّف المرجعي",
      "View": "عرض",
      "No activity logs found": "لم يتم العثور على سجلات نشاط",
      "Error loading activity logs": "خطأ في تحميل سجلات النشاط",
      "Before": "قبل",
      "After": "بعد",
      "Search user or module...": "ابحث عن مستخدم أو وحدة...",
      "Date range (YYYY-MM-DD - YYYY-MM-DD)": "نطاق التاريخ (سنة-شهر-يوم - سنة-شهر-يوم)",
      "Change Email or Password": "تغيير البريد الإلكتروني أو كلمة المرور",
      "Update Email": "تحديث البريد الإلكتروني",
      "Old(Current) Password": "كلمة المرور القديمة (الحالية)",
      "Enter Your Old Password": "أدخل كلمة مرورك القديمة",
      "New Password": "كلمة المرور الجديدة",
      "Enter New Password": "أدخل كلمة المرور الجديدة",
      "Confirm Password": "تأكيد كلمة المرور",
      "Enter Confirm Password": "أدخل تأكيد كلمة المرور",
      "Change Password": "تغيير كلمة المرور",
      // ── Ad Details ─────────────────────────────────────────────
      "Ad Details": "تفاصيل الإعلان",
      "Draft — Status locked": "مسودة — الحالة مقفلة",
      "Processing…": "جارٍ المعالجة…",
      "Approved": "موافق عليه",
      "Paused": "متوقف مؤقتًا",
      "Basic Information": "المعلومات الأساسية",
      "Sub Category": "الفئة الفرعية",
      "Category Type": "نوع الفئة",
      "Ad Destination": "وجهة الإعلان",
      "CTA Button Text": "نص زر الحث على الإجراء",
      "Target Ad": "الإعلان المستهدف",
      "Payment Method:": "طريقة الدفع:",
      "Transaction ID:": "معرّف المعاملة:",
      "Pay Amount:": "مبلغ الدفع:",
      "Same Content": "نفس المحتوى",
      "image(s)": "صورة/صور",
      "field(s)": "حقل/حقول",
      "Analytics": "التحليلات",
      "Ad Performance": "أداء الإعلان",
      "Total Clicks": "إجمالي النقرات",
      "Reach": "الوصول",
      "Outbound Clicks": "النقرات الصادرة",
      "Ad Duration": "مدة الإعلان",
      "Remaining Duration": "المدة المتبقية",
      "Bounce Rate": "معدل الارتداد",
      "Repeat Visitors": "الزوار المتكررون",
      "Engagement Metrics": "مقاييس التفاعل",
      "Favorites": "المفضلة",
      "Comments": "التعليقات",
      "Engagement Score": "نتيجة التفاعل",
      "Scroll Depth": "عمق التمرير",
      "Average Time on Ad": "متوسط الوقت على الإعلان",
      "Conversion & Contact": "التحويل والتواصل",
      "Messages": "الرسائل",
      "Cost Per Message": "تكلفة كل رسالة",
      "Conversion Rate": "معدل التحويل",
      "Financial Metrics": "المقاييس المالية",
      "Average CPC": "متوسط تكلفة النقرة",
      "Average CPM": "متوسط تكلفة الألف ظهور",
      "Cost Per Contact": "تكلفة كل جهة اتصال",
      "Click Through Rate": "معدل النقر إلى الظهور",
      "Audience and Reach": "الجمهور والوصول",
      "Top Locations": "أهم المواقع",
      "Traffic Sources": "مصادر الزيارات",
      "No analytics data available.": "لا توجد بيانات تحليلية متاحة.",
      "Advertiser Details": "تفاصيل المُعلن",
      "View advertiser profile": "عرض ملف المُعلن",
      "country/countries": "دولة/دول",
      "city/cities": "مدينة/مدن",
      "Performance Overview": "نظرة عامة على الأداء",
      "Views, clicks, reach, shares & engagement": "المشاهدات والنقرات والوصول والمشاركات والتفاعل",
      "Engagement Breakdown": "تفصيل التفاعل",
      "Shares, comments & favorites": "المشاركات والتعليقات والمفضلة",
      "No engagement data yet": "لا توجد بيانات تفاعل بعد",
      "Views & Clicks Over Time": "المشاهدات والنقرات عبر الوقت",
      "Daily/weekly activity timeline": "الجدول الزمني للنشاط اليومي/الأسبوعي",
      "Audience by Country": "الجمهور حسب الدولة",
      "Views and clicks per user country": "المشاهدات والنقرات حسب دولة المستخدم",
      "Rate Metrics": "مقاييس المعدلات",
      "CTR, bounce rate, scroll depth & conversion": "معدل النقر ومعدل الارتداد وعمق التمرير والتحويل",
      "Reject Ad": "رفض الإعلان",
      "Rejection Reason": "سبب الرفض",
      "Enter rejection reason (optional)…": "أدخل سبب الرفض (اختياري)…",
      "Do you want to change the status to": "هل تريد تغيير الحالة إلى",
      "Yes, update it!": "نعم، حدّثها!",
      "Processing Rejection…": "جارٍ معالجة الرفض…",
      "Updating Status…": "جارٍ تحديث الحالة…",
      "Sending notification and processing refund. Please wait…": "جارٍ إرسال الإشعار ومعالجة الاسترداد. يرجى الانتظار…",
      "Please wait…": "يرجى الانتظار…",
      "Updated!": "تم التحديث!",
      "Ad status has been updated to": "تم تحديث حالة الإعلان إلى",
      "Error!": "خطأ!",
      "Failed to update ad status.": "فشل تحديث حالة الإعلان.",
      "Error loading ad details": "خطأ في تحميل تفاصيل الإعلان",
      "Ad not found": "لم يتم العثور على الإعلان",
    // ── Reports & Complaints (moderation) ──────────────────────
    "Reports & Complaints": "البلاغات والشكاوى",
    "Pending Review": "بانتظار المراجعة",
    "Reviewed": "تمت المراجعة",
    "Resolved": "تم الحل",
    "Dismissed": "مرفوض",
    "reviewed": "تمت المراجعة",
    "resolved": "تم الحل",
    "dismissed": "مرفوض",
    "Search reporter, ad, reason...": "ابحث عن المُبلِّغ أو الإعلان أو السبب...",
    "All Report Types": "جميع أنواع البلاغات",
    "Ad Reports": "بلاغات الإعلانات",
    "User Reports": "بلاغات المستخدمين",
    "Ad Report": "بلاغ إعلان",
    "User Report": "بلاغ مستخدم",
    "Reporter": "المُبلِّغ",
    "Reported": "المُبلَّغ عنه",
    "Reported User": "المستخدم المُبلَّغ عنه",
    "Reported Ad": "الإعلان المُبلَّغ عنه",
    "Action Taken": "الإجراء المتخذ",
    "Submitted": "تاريخ الإرسال",
    "No reports found": "لا توجد بلاغات",
    "Report not found": "البلاغ غير موجود",
    "Report Details": "تفاصيل البلاغ",
    "Reported User History": "سجل المستخدم المُبلَّغ عنه",
    "Reports against their ads": "بلاغات ضد إعلاناته",
    "Reports against them": "بلاغات ضده",
    "Recorded violations": "المخالفات المسجلة",
    "Review & Decision": "المراجعة والقرار",
    "Decision": "القرار",
    "Reviewed — looked at, no decision yet": "تمت المراجعة — تم الاطلاع دون قرار بعد",
    "Accept report — valid, action taken": "قبول البلاغ — صحيح وتم اتخاذ إجراء",
    "Reject report — invalid or unfounded": "رفض البلاغ — غير صحيح أو لا أساس له",
    "No action — record decision only": "بدون إجراء — تسجيل القرار فقط",
    "Issue warning to the reported user": "إصدار تحذير للمستخدم المُبلَّغ عنه",
    "Suspend the reported account": "تعليق الحساب المُبلَّغ عنه",
    "Remove the reported ad": "إزالة الإعلان المُبلَّغ عنه",
    "No Action": "بدون إجراء",
    "Warning Issued": "تم إصدار تحذير",
    "Account Suspended": "تم تعليق الحساب",
    "Ad Removed": "تمت إزالة الإعلان",
    "Admin Note": "ملاحظة المشرف",
    "Why was this decision made? (visible to admins only)": "لماذا تم اتخاذ هذا القرار؟ (يظهر للمشرفين فقط)",
    "Submit Decision": "إرسال القرار",
    "Submitting...": "جارٍ الإرسال...",
    "Confirm Review Decision": "تأكيد قرار المراجعة",
    "Yes, submit": "نعم، إرسال",
    "Report reviewed successfully!": "تمت مراجعة البلاغ بنجاح!",
    "Failed to review report. Please try again.": "فشل في مراجعة البلاغ. يرجى المحاولة مرة أخرى.",
    "You do not have permission to review reports.": "ليس لديك صلاحية لمراجعة البلاغات.",
    "You do not have permission to take action on reports.": "ليس لديك صلاحية لاتخاذ إجراء على البلاغات.",
    "Last reviewed by": "آخر مراجعة بواسطة",
    "Back to Reports": "العودة إلى البلاغات",
    "Evidence": "الأدلة",
    "Unknown User": "مستخدم غير معروف",
    "Review": "مراجعة",
    "AFFECTED CONTENT": "المحتوى المتأثر",
    "Accepted: JPG, PNG, PDF, DOC, DOCX (max 5MB each)": "الصيغ المقبولة: JPG, PNG, PDF, DOC, DOCX (بحد أقصى 5 ميجابايت لكل ملف)",
    "Account Deactivated": "الحساب معطل",
    "Account Status": "حالة الحساب",
    "Account deactivated.": "تم تعطيل الحساب.",
    "Account reactivated.": "تم إعادة تفعيل الحساب.",
    "Ad Reports Against This User's Ads": "بلاغات على إعلانات هذا المستخدم",
    "Ad Reports Filed By This User": "بلاغات قدمها هذا المستخدم على إعلانات",
    "Add a note for this approval...": "أضف ملاحظة لهذه الموافقة...",
    "Add a note for this rejection...": "أضف ملاحظة لهذا الرفض...",
    "Add an internal note about this decision…": "أضف ملاحظة داخلية حول هذا القرار…",
    "Additional details about this violation…": "تفاصيل إضافية حول هذه المخالفة…",
    "Affected Ad": "الإعلان المتأثر",
    "Appeal Awaiting Review": "استئناف بانتظار المراجعة",
    "Appeal approved.": "تمت الموافقة على الاستئناف.",
    "Appeal attachment": "مرفق الاستئناف",
    "Appeal rejected.": "تم رفض الاستئناف.",
    "Approve Appeal": "الموافقة على الاستئناف",
    "Approve Badge": "الموافقة على الشارة",
    "Attachments": "المرفقات",
    "Badge Documents": "مستندات الشارة",
    "Badge Note": "ملاحظة الشارة",
    "Classification": "التصنيف",
    "Contact Phone": "رقم الهاتف",
    "DATE": "التاريخ",
    "Deactivate Account": "تعطيل الحساب",
    "Deactivated By": "تم التعطيل بواسطة",
    "Deactivated On": "تاريخ التعطيل",
    "Deactivated for": "تم التعطيل بسبب",
    "Deactivated on": "تم التعطيل في",
    "Deactivation Reason": "سبب التعطيل",
    "Deduct": "خصم",
    "Deduct Balance": "خصم الرصيد",
    "Deduct Wallet Balance": "خصم رصيد المحفظة",
    "Documents": "المستندات",
    "Explain why this appeal is being rejected…": "اشرح سبب رفض هذا الاستئناف…",
    "Explanation": "التوضيح",
    "Failed to issue violation.": "فشل إصدار المخالفة.",
    "Failed to review appeal.": "فشل مراجعة الاستئناف.",
    "Failed to update account status.": "فشل تحديث حالة الحساب.",
    "Failed to update verification status.": "فشل تحديث حالة التحقق.",
    "Failed to update wallet.": "فشل تحديث المحفظة.",
    "Give Violation": "إصدار مخالفة",
    "Joined Date": "تاريخ الانضمام",
    "No ads found for this user.": "لا توجد إعلانات لهذا المستخدم.",
    "No ads found. Switch to the Ads tab to load them first.": "لا توجد إعلانات. انتقل إلى تبويب الإعلانات لتحميلها أولاً.",
    "No reports have been filed against this user's ads.": "لم يتم تقديم أي بلاغات ضد إعلانات هذا المستخدم.",
    "No reports have been filed against this user.": "لم يتم تقديم أي بلاغات ضد هذا المستخدم.",
    "No violations found for this user.": "لا توجد مخالفات لهذا المستخدم.",
    "Owner": "المالك",
    "Please enter a reason for rejecting this appeal.": "يرجى إدخال سبب رفض هذا الاستئناف.",
    "Please select an ad.": "يرجى اختيار إعلان.",
    "Policy Non-Compliance": "عدم الامتثال للسياسات",
    "Profile Details": "تفاصيل الملف الشخصي",
    "Reactivate": "إعادة تفعيل",
    "Reactivate Account": "إعادة تفعيل الحساب",
    "Reason": "السبب",
    "Reason for rejection": "سبب الرفض",
    "Reject Appeal": "رفض الاستئناف",
    "Reject Badge": "رفض الشارة",
    "Report image": "صورة البلاغ",
    "Reports Against This User": "بلاغات ضد هذا المستخدم",
    "Restricted": "مقيّد",
    "Review Note": "ملاحظة المراجعة",
    "Reviewed By": "تمت المراجعة بواسطة",
    "Select an ad…": "اختر إعلانًا…",
    "Signin Method": "طريقة تسجيل الدخول",
    "Submitted On": "تاريخ التقديم",
    "Submitted on": "تم التقديم في",
    "Submitting…": "جارٍ الإرسال…",
    "TYPE OF VIOLATION": "نوع المخالفة",
    "The account stays deactivated. The user will be notified with the reason you enter below.": "سيبقى الحساب معطلاً. سيتم إعلام المستخدم بالسبب الذي تدخله أدناه.",
    "The account will be reactivated immediately and the user will be notified that they can sign in again.": "سيتم إعادة تفعيل الحساب فورًا وسيتم إعلام المستخدم بإمكانية تسجيل الدخول مرة أخرى.",
    "The user will be signed out of the platform and blocked from signing in again. They will be notified with the reason you enter below.": "سيتم تسجيل خروج المستخدم من المنصة ومنعه من تسجيل الدخول مرة أخرى. سيتم إعلامه بالسبب الذي تدخله أدناه.",
    "The user will regain access to the platform and be notified that their account is active again.": "سيستعيد المستخدم الوصول إلى المنصة وسيتم إعلامه بأن حسابه نشط مرة أخرى.",
    "This user cannot use the platform.": "لا يمكن لهذا المستخدم استخدام المنصة.",
    "This user has appealed their deactivation. Review the details below and approve or reject the appeal.": "قدّم هذا المستخدم استئنافًا على تعطيل حسابه. راجع التفاصيل أدناه ووافق على الاستئناف أو ارفضه.",
    "This user has not reported any ads.": "لم يقم هذا المستخدم بالإبلاغ عن أي إعلانات.",
    "Type of Violation": "نوع المخالفة",
    "Under Review": "قيد المراجعة",
    "Unknown": "غير معروف",
    "Upload Documents": "رفع المستندات",
    "User Ads": "إعلانات المستخدم",
    "User Appeal": "استئناف المستخدم",
    "User Details": "تفاصيل المستخدم",
    "User Info": "معلومات المستخدم",
    "User not found": "المستخدم غير موجود",
    "User verification approved successfully!": "تمت الموافقة على تحقق المستخدم بنجاح!",
    "User verification rejected successfully!": "تم رفض تحقق المستخدم بنجاح!",
    "User's explanation": "توضيح المستخدم",
    "Violation issued successfully!": "تم إصدار المخالفة بنجاح!",
    "Violations": "المخالفات",
    "Wallet Balance": "رصيد المحفظة",
    "by": "بواسطة",
    "e.g. Policy Non-Compliance": "مثال: عدم الامتثال للسياسات",
    "e.g. Refund, penalty, bonus…": "مثال: استرداد، غرامة، مكافأة…",
    "on": "في",
    "report": "بلاغ",
    "reports": "بلاغات",
    "Toggle Status": "تبديل الحالة",
    "All": "الكل",
    "Are you sure you want to delete? It may affect your products information": "هل أنت متأكد من الحذف؟ قد يؤثر ذلك على معلومات منتجاتك",
    "Category - Properties": "الفئة - الخصائص",
    "Enter Main Title": "أدخل العنوان الرئيسي",
    "Failed to delete property. Please try again.": "فشل حذف الخاصية. يرجى المحاولة مرة أخرى.",
    "Failed to update properties. Please try again.": "فشل تحديث الخصائص. يرجى المحاولة مرة أخرى.",
    "Is Locked": "مقفل",
    "Parent Title": "العنوان الرئيسي",
    "Parent Title Ar": "العنوان الرئيسي بالعربية",
    "Properties updated successfully!": "تم تحديث الخصائص بنجاح!",
    "Property Name": "اسم الخاصية",
    "Property Name Ar": "اسم الخاصية بالعربية",
    "Property deleted successfully!": "تم حذف الخاصية بنجاح!",
    "optional": "اختياري",
    "Enter Title Arabic": "أدخل العنوان بالعربية",
    "Failed to delete subcategory. Please try again.": "فشل حذف الفئة الفرعية. يرجى المحاولة مرة أخرى.",
    "Failed to update subcategories. Please try again.": "فشل تحديث الفئات الفرعية. يرجى المحاولة مرة أخرى.",
    "SubCategories updated successfully!": "تم تحديث الفئات الفرعية بنجاح!",
    "SubCategory deleted successfully!": "تم حذف الفئة الفرعية بنجاح!",
    "You want to logout": "تريد تسجيل الخروج",
    "Yes, logout!": "نعم، تسجيل الخروج!",
    "Yes, delete it!": "نعم، احذفه!",
  }


};

export default adminTranslations;
